<template>
  <div>
    <div v-if="loading">
      <az-loading />
    </div>

    <div v-else>
      <template v-if="paciente">
        <ficha-paciente :paciente="paciente" :panel="panel" @atualizado="reload_pac()" 
          :id_unidade_operacao="marcacao_pra_chamar ? marcacao_pra_chamar.id_unidade_operacao : null" />
        <historico-pacotes-paciente ref="histpacote" />
        <lista-orcamentos :orcs="orcs" />
        <lembrete-paciente v-model="paciente" ref="lembrete_pac_perfil" />

        <div v-if="!block_foto && paciente && paciente.logo && paciente.logo.arquivo && paciente.logo.arquivo.temporary_url && is_image(paciente.logo.arquivo)" class="text-center mb-3">
            <viewer :images="[paciente.logo.arquivo.temporary_url]">
                <img :src="paciente.logo.arquivo.temporary_url" class="img-fluid img-thumbnail" style="max-width: 200px; max-height: 130px; cursor: pointer;">
            </viewer>
        </div>
      </template>

      <template v-else-if="temporario">
        <div v-if="temporario.st_cpf || temporario.st_numero_carteira">
          <div class="row mb-3">
            <div class="col col-12 col-md-4" v-if="temporario.st_cpf">
              <az-input
                type="cpf"
                label="CPF"
                :edicao="false"
                v-model="temporario.st_cpf" />
            </div>
            <div class="col col-12 col-md-4" v-if="temporario.st_numero_carteira">
              <az-input
                label="Número da Matrícula"
                :edicao="false"
                v-model="temporario.st_numero_carteira" />
            </div>
            <div class="col col-12 col-md-4" v-if="temporario.st_numero_carteira">
              <az-input
                label="Validade da Matrícula"
                type="date"
                :edicao="false"
                v-model="temporario.dt_validade_carteira" />
            </div>
          </div>
        </div>

      </template>

      <div class="form-group">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">
              <i class="fas fa-search" v-if="!$store.state.loading"></i>
              <div class="spinner-grow spinner-grow-sm" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
            </span>
          </div>
          <input
            id="pep-pesquisa"
            type="text"
            class="form form-control"
            v-model="search"
            placeholder="Pesquisar..."
            @input="pesquisar ()"
          />
          <div class="input-group-append"> 
            <button class="btn btn-outline-primary" type="button" @click="tour ()">
              <i class="far fa-compass"></i>
            </button>

            <button class="btn btn-outline-primary" type="button" @click="abrir_pagamentos ()">
              <i class="fas fa-dollar-sign"></i>
            </button>

            <button type="button" class="btn btn-outline-primary" @click="$refs.histpacote.abrir(paciente.id_pessoa)"
              v-if="1 == 1 || $store.state.user.id_usuario == 1">
              <i class="fas fa-layer-group"></i>
            </button>

            <!-- Impressão -->
            <span>
              <button class="btn btn-outline-secondary rounded-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" v-if="listMode == 'L'" title="Imprimir">
                <i class="fa fa-print fa-fw" aria-hidden="true"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" href="#" @click="imprimir('C')" v-if="paciente">Completo</a>
                <a class="dropdown-item" href="#" @click="imprimir('N')" v-if="paciente">Anotações em Prontuário</a>
                <a class="dropdown-item" href="#" @click="imprimir_agendas()">Agendas Marcadas</a>
              </div>
            </span>

            <!-- Filtro -->
            <span>
              <button class="btn btn-outline-secondary rounded-0" type="button" id="dropdownMenuButton" data-toggle="dropdown">
                <i class="fa-solid fa-filter fa-fw" v-if="!tipo_filtro"></i>
                <i class="fa-solid fa-prescription fa-fw" v-else-if="tipo_filtro == 'receita'"></i>
                <i class="fa-solid fa-heart-pulse fa-fw" v-else-if="tipo_filtro == 'requisicao'"></i>
                <i class="fa-regular fa-file-lines fa-fw" v-else-if="tipo_filtro == 'documento'"></i>
                <i class="fa-solid fa-file-medical fa-fw" v-else-if="tipo_filtro == 'modelo'"></i>
                <i class="fa-solid fa-plus fa-fw" v-else-if="tipo_filtro == 'atestado'"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" href="#" @click="definir_filtro()"><i class="fa-solid fa-globe fa-fw mr-2"></i>Todos os registros</a>
                <a class="dropdown-item" href="#" @click="definir_filtro('receita')"><i class="fa-solid fa-prescription fa-fw mr-2"></i>Receitas/Prescrições</a>
                <a class="dropdown-item" href="#" @click="definir_filtro('requisicao')"><i class="fa-solid fa-heart-pulse fa-fw mr-2"></i>Requisições</a>
                <a class="dropdown-item" href="#" @click="definir_filtro('documento')"><i class="fa-regular fa-file-lines fa-fw mr-2"></i>Documentos/Relatórios</a>
                <a class="dropdown-item" href="#" @click="definir_filtro('atestado')"><i class="fa-solid fa-plus fa-fw mr-2"></i>Atestados</a>
                <a class="dropdown-item" href="#" @click="filtrar_periodo()"><i class="fa-regular fa-calendar-check fa-fw mr-2"></i>Filtrar Período</a>
                <a class="dropdown-item" href="#" @click="filtrar_modelo()"><i class="fa-solid fa-file-medical fa-fw mr-2"></i>Filtrar Modelo de Prontuário</a>

                <a class="dropdown-item" href="#" @click="resumo_medicamentos()"><i class="fa-solid fa-book-medical fa-fw mr-2"></i>Histórico Medicamentos</a>
              </div>
            </span>

            <!-- Tamanho -->
            <span>
              <button class="btn btn-outline-secondary rounded-0" type="button" id="dropdownMenuButton" data-toggle="dropdown">
                <i class="fa-solid fa-fw" :class="'fa-' + tamanho.toLowerCase()"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" href="#" @click="definir_tamanho_fonte('G')"><i class="fas fa-font mr-2"></i>Grande</a>
                <a class="dropdown-item" href="#" @click="definir_tamanho_fonte('M')"><i class="fas fa-font mr-2"></i>Média</a>
                <a class="dropdown-item" href="#" @click="definir_tamanho_fonte('P')"><i class="fas fa-font mr-2"></i>Pequena</a>
              </div>
            </span>

            <!-- Modo de Visualização -->
            <span>
              <button class="btn btn-outline-secondary rounded-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" title="Modo de Visualização.">
                <i class="fas fa-dollar-sign fa-fw" v-if="listMode == 'C'"></i>
                <i class="fas fa-th-list fa-fw" v-else-if="listMode == 'S'"></i>
                <i class="fas fa-bars fa-fw" v-else></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" href="#" @click="toggle_modo_view('S')"><i class="fas fa-th-list fa-fw mr-2"></i>Barra Lateral</a>
                <a class="dropdown-item" href="#" @click="toggle_modo_view('L')"><i class="fas fa-bars fa-fw mr-2"></i>Visão de Lista</a>
                <a class="dropdown-item" href="#" @click="toggle_modo_view('C')"><i class="fas fa-dollar-sign fa-fw mr-2"></i>Visão de Cobrança</a>
              </div>
            </span>

            <!-- Lembrete -->
            <button id="botao-lembrete-perfil" v-if="paciente" type="button" class="btn btn-outline-secondary" data-toggle="tooltip" data-placement="top" 
              title="Lembrete relacionado ao paciente." @click="$refs.lembrete_pac_perfil.editar()">
              <i class="fas fa-thumbtack fa-fw"></i>
            </button>

            <!-- Novo Agendamento -->
            <button class="btn btn-outline-success" type="button" @click="adicionar_marcacao ()" id="pep-add-marcacao"
              data-toggle="tooltip" data-placement="top" title="Realizar Marcação">
              <i class="fas fa-calendar-plus fa-fw"></i>
            </button>

            <!-- Galeria de Imagens -->
            <button type="button" class="btn btn-outline-success" data-toggle="tooltip" data-placement="top" title="Anexos." @click="abrir_galeria_imagens(true)">
              <i class="fa-solid fa-paperclip fa-fw"></i>
            </button>

            <template v-if="$store.state.user.medico || ( $store.state.user.delegantes_medicos && $store.state.user.delegantes_medicos.length > 0 ) || $store.state.user.id_usuario == 1">
              <!-- Galeria de Imagens -->
              <button id="botao-galeria-de-imagens-perfil" type="button" class="btn btn-outline-success"
                data-toggle="tooltip" data-placement="top" title="Galeria de Imagens."
                @click="abrir_galeria_imagens()">
                <i class="fas fa-images fa-fw"></i>
              </button>

              <!-- Resultados -->
              <button class="btn btn-outline-success" type="button" @click="ver_resultados ()" v-if="resultados && resultados.length"
                id="pep-ver-resultados"
                data-toggle="tooltip"
                data-placement="top"
                title="Tabela de Resultados de Exames">
                <i class="fa fa-table fa-fw" aria-hidden="true"></i>
              </button>

              <button class="btn btn-outline-success" type="button" :disabled="verificando_resultado" @click="baixar_resultados_labs ()" v-if="is_labs"
                data-toggle="tooltip"
                data-placement="top"
                title="Verificar Histórico Laboratorial">
                <i class="fa-solid fa-vial-circle-check fa-fw" v-if="!verificando_resultado"></i>
                <div class="spinner-grow spinner-grow-sm" role="status" v-else>
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
            </template>

            <template v-if="$store.state.user.medico || pode_avulso || ( $store.state.user.delegantes_medicos && $store.state.user.delegantes_medicos.length > 0 ) || $store.state.user.id_usuario == 1">
              <!-- Atendimento Avulso -->
              <button class="btn btn-outline-success" type="button" @click="novo_atendimento_avulso()"
                id="pep-novo-atendimento"
                v-if="panel && id"
                data-toggle="tooltip"
                data-placement="top"
                :disabled="incluindo_avulso"
                title="Registrar Atendimento Avulso">
                <i class="fas fa-plus fa-fw" v-if="!incluindo_avulso"></i>
                <div class="spinner-border spinner-border-sm" role="status" v-else>
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
            </template>

            <button class="btn btn-outline-primary" type="button" @click="toggle_expandir ()"
              id="pep-detalhes"
              data-toggle="tooltip"
              data-placement="top"
              :disabled="listMode == 'S'"
              title="Expandir/Recolher detalhes dos atendimentos.">
              <i class="fas fa-compress-arrows-alt fa-fw" v-if="expandido"></i>
              <i class="fas fa-expand-arrows-alt fa-fw" v-else></i>
            </button>
          </div>
        </div>
      </div>

      <div v-if="modelo_pront_selecionado" class="alert-warning d-flex justify-content-between">
        <div>
          <span class="ml-2">{{ modelo_pront_selecionado.st_modelo_prontuario }}</span>
        </div>
        <div>
          <a href="#" @click.prevent="selecao_modelo()" class="mr-2">
            <i class="fa fa-times text-danger" aria-hidden="true"></i>
          </a>
        </div>
      </div>

      <div class="mb-3" v-if="marcacao_pra_chamar && !panel">
        <div class="form-row mb-2" v-if="lista_locais.length">
          <div class="col col-12">
            <az-input
              sizing="sm"
              type="button-group"
              :optionsList="lista_locais"
              optionsData="id"
              v-model="local_item" />
          </div>
        </div>
        <div class="form-row">
          <div class="col col-12 col-md-4 d-flex flex-column">
            <button 
              id="pep-chamar-novamente"
              type="button"
              class="btn btn-outline-danger"
              :disabled="rechamado"
              @click="chamarNovamente(marcacao_pra_chamar)">
              <i class="fas fa-bell mr-2" v-if="!$store.state.loading"></i>
              <div class="spinner-border spinner-border-sm" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
              Chamar Novamente
            </button>
          </div>
          <div class="col col-12 col-md-4 d-flex flex-column">
            <button 
              v-if="marcacao_pra_chamar"
              type="button"
              class="btn btn-outline-success"
              id="pep-iniciar-atendimento"
              @click="iniciarAtendimento(marcacao_pra_chamar)">
              <i class="fas fa-play mr-2" v-if="!$store.state.loading"></i>
              <div class="spinner-border spinner-border-sm" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
              Iniciar Atendimento
            </button>
          </div>
          <div class="col col-12 col-md-4 d-flex flex-column">
            <button 
              v-if="marcacao_pra_chamar"
              type="button"
              class="btn btn-outline-secondary"
              id="pep-nao-iniciar-atendimento"
              @click="naoComparecer(marcacao_pra_chamar)">
              <i class="fas fa-times mr-2" v-if="!$store.state.loading"></i>
              <div class="spinner-border spinner-border-sm" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
              Paciente não compareceu
            </button>
          </div>
        </div>

        <!-- Validação de Código de Barras do Atendimento -->
        <div class="form-row mt-3" v-if="validar_codigo">
          <div class="col col-12 d-flex flex-column">
            <button 
              id="pep-chamar-novamente"
              type="button"
              class="btn btn-link"
              @click="validarCodigoAtendimento()">
              <i class="fa-solid fa-barcode-scan mr-2" v-if="!$store.state.loading"></i>
              <div class="spinner-border spinner-border-sm" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
              Validar Código do Atendimento
            </button>
          </div>
        </div>

      </div>

      <lista-retornos :retornos="retornos" v-if="listMode == 'L'" />

      <div v-if="autorizacoes && autorizacoes.length">
        <historico-marcacoes
          ref="historico_pep"
          :autorizacao="autorizacoes"
          @revisao="adicionar_marcacao" />
      </div>

      <az-empty-state
        :msg="search ? 'Nenhum registro encontrado.' : 'Nenhum registro realizado.'"
        :icon="search ? 'fas fa-search' : 'far fa-file-alt'"
        v-if="( !lista || !lista.length ) && ( !lista_legado || !lista_legado.length )"
      />

      <!-- Lista com Side Bar -->
      <pep-side-bar 
        ref="pepsidebar"
        :filtro_periodo_aplicado="filtro_periodo_aplicado"
        :retornos="retornos"
        :marcacao_pra_chamar="marcacao_pra_chamar"
        :panel="panel"
        :lista="lista" 
        :lista_legado="lista_legado"
        :paciente="paciente"
        :tamanho="tamanho" 
        :pode_atender="pode_atender"
        :qt_agendados="qt_agendados"
        :exibir_agendados="exibir_agendados"
        v-else-if="listMode == 'S'" 
        @abrirAtendimentoNaRecepcao="abrirAtendimentoNaRecepcao" 
        @retornarAoAtendimento="retornarAoAtendimento"
        @compartilhar="compartilhar"
        @cancelar_marcacao="cancelar_marcacao"
        @registrarAtendimento="registrarAtendimento" 
        @chamar="chamar" 
        @iniciarAtendimento="iniciarAtendimento" 
        @abrir_doc_view="abrir_doc_view"
        @limpar_filtro_periodo="filtro_periodo_aplicado = null; filtrar();" 
        @toggle_agendados="exibir_agendados = !exibir_agendados; filtrar();" />

      <!-- Linha do Tempo -->

      <div id="impressao-historico" v-else-if="listMode == 'L' || listMode == 'C'">

        <div v-if="paciente && qt_agendados > 10" class="mb-3">
            <button type="button" class="btn" :class="exibir_agendados ? 'btn-dark' : 'btn-outline-dark'" @click="exibir_agendados = !exibir_agendados; filtrar();">
                <i class="fa-solid fa-eye-slash fa-fw mr-2" v-if="!exibir_agendados"></i>
                <i class="fa-solid fa-eye fa-fw mr-2" v-else></i>
                {{ qt_agendados }} Procedimentos Agendados
            </button>
        </div>

        <table class="table table-sm table-borderless">
          <thead v-if="imprimindo">
            <tr>
              <td>
                <cabecalho-generico :titulo="model_print == 'A' ? 'Marcações' : 'Histórico'" v-if="paciente">
                  <div class="row">
                    <div class="col col-12 col-md-8">
                      Paciente: {{ paciente.st_nome }} 
                    </div>
                    <div class="col col-12 col-md-4" v-if="paciente.cadastro">
                      RG: {{ paciente.cadastro.st_rg }} 
                    </div>
                  </div>

                  <div class="row" v-if="paciente.cadastro">
                    <div class="col col-12 col-md-8">
                      Data de Nascimento: {{ $util.getFormatDate(paciente.cadastro.dt_nascimento) }}
                    </div>
                    <div class="col col-12 col-md-4">
                      CPF: {{ paciente.cadastro.st_cpf }} 
                    </div>
                  </div>
                </cabecalho-generico>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-if="filtro_periodo_aplicado">
              <td class="p-0">
                <div class="alert alert-secondary d-flex justify-content-between">
                  <div>
                    <strong>Período:</strong> 
                    <span v-if="filtro_periodo_aplicado.dt_inicio && filtro_periodo_aplicado.dt_fim">
                      {{ $util.getFormatDate(filtro_periodo_aplicado.dt_inicio) }} a {{ $util.getFormatDate(filtro_periodo_aplicado.dt_fim) }}
                    </span>
                    <span v-else-if="filtro_periodo_aplicado.dt_inicio">
                      A partir de {{ $util.getFormatDate(filtro_periodo_aplicado.dt_inicio) }} 
                    </span>
                    <span v-else-if="filtro_periodo_aplicado.dt_fim">
                      Até {{ $util.getFormatDate(filtro_periodo_aplicado.dt_fim) }}
                    </span>
                  </div>
                  <div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="filtro_periodo_aplicado = null; filtrar();">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            <template v-for="(marcacao, idx) in lista">

              <tr :key="idx" v-if="!imprimindo || ( marcacao.id_atendimento && model_print != 'A' ) || ( !marcacao.id_atendimento && marcacao.ch_estado_marcacao == 'A' && model_print == 'A' )">
                <td class="p-0">

                  <div v-if="marcacao.corte" :key="'h' + idx" class="d-flex flex-column mb-3 d-print-none">
                    <span class="badge badge-secondary">
                      {{ $util.getFormatDate($util.hoje()) }}, HOJE
                    </span>
                  </div>

                  <div class="card" :key="'m' + idx" style="padding: 0px;" :class="( !marcacao.id_atendimento && model_print != 'A' ) ? 'd-print-none' : ''"> <!-- model_print == 'N' &&  -->
                    <div class="card-header d-flex justify-content-between" v-if="imprimindo || model_print == 'N'" class2="model_print == 'N' ? 'd-print-block' : '' / d-none d-print-block">
                      <div>
                        {{ $util.getFormatDate(marcacao.dt_inicio) }} {{ marcacao.dt_inicio.substr(11,5) }} 
                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                        {{ marcacao.medico.st_nome_exibicao }}
                        <span v-if="marcacao.medico.conselho" class="ml-3">
                          {{ marcacao.medico.conselho.st_sigla }}
                          <span>{{ marcacao.medico.in_numero_conselho }}</span> 
                        </span> 

                        <!-- Impressão das Marcações -->
                        <div v-if="imprimindo && !marcacao.id_atendimento" class="mt-2">

                            <div>
                                No: M{{ marcacao.id_marcacao }} / <span v-if="marcacao.unidade_operacao">{{ marcacao.unidade_operacao.st_sigla }}</span>
                            </div>

                            <div v-if="marcacao.recorrencias">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                                <span class="ml-2" v-for="(rec, irecx) in marcacao.recorrencias" :key="irecx">
                                    {{ $util.getFormatDate(rec) }}
                                </span>
                            </div>

                        </div>
                      </div>
                      <div class="small">
                        {{ marcacao.procedimento.st_procedimento }}
                      </div>
                    </div>
                    <div class="card-header d-flex justify-content-between d-block d-print-none"
                      :class="
                        ( model_print == 'N' ? 'd-block d-print-none ' : '' ) + 
                        ( 
                          ( marcacao.ch_estado_marcacao == 'B' || marcacao.ch_estado_marcacao == 'C' ) ? 'alert-danger' : ( 
                          marcacao.item_status.valor == 'agendado' ? 'alert-primary' : 
                            ( marcacao.item_status.valor == 'faltoso' ? 'alert-danger' : '' ) )
                        )">
                      <div>
                        <div>
                          <a class="card-link" href="#" role="button" aria-expanded="false" aria-controls="collapseExample"
                            @click.prevent="marcacao.resumido = !marcacao.resumido">
                            <i class="far fa-calendar-alt mr-2"></i>
                            {{ getHumanDate(marcacao.dt_inicio) }}, 
                            <span>{{ getHumanDay(marcacao.dt_inicio) }}, </span> 
                            <small>{{ getHumanDuration(marcacao.dt_inicio) }}</small>
                          </a>

                          <span class="ml-3 badge badge-danger" v-if="marcacao.ch_estado_marcacao == 'B'">
                            <i class="fa fa-ban mr-2" aria-hidden="true"></i>
                            Agenda Bloqueada
                          </span>
                          <span class="ml-3 badge badge-danger" v-if="marcacao.ch_estado_marcacao == 'C'">
                            <i class="fas fa-times-square mr-2" aria-hidden="true"></i>
                            Agenda Cancelada
                          </span>
                        </div>
                        <div>
                          <i class="far fa-clock mr-2"></i>
                          <small>{{ marcacao.dt_inicio.substr(11,5) }}</small>
                          <span class="badge badge-light ml-3" v-if="marcacao.unidade_operacao && marcacao.unidade_operacao.st_sigla">
                            {{ marcacao.unidade_operacao.st_sigla }}
                          </span>

                          <template v-if="marcacao && marcacao.id_marcacao">
                            <a href="#" @click.prevent="enviar_arquivo(marcacao, 'marcacao', 'id_marcacao')" class="card-link m-0">
                              <span data-toggle2="tooltip" data-placement="top" title="Anexar Arquivos">
                                <i class="fa fa-paperclip ml-2" aria-hidden="true" 
                                  v-if="marcacao && marcacao.arquivos && marcacao.arquivos.length"></i>
                                <i class="fas fa-plus ml-2" v-else></i>
                              </span>
                            </a>
                          </template>
                          
                          <span v-if="marcacao.fl_tele_atendimento" class="text-muted ml-3">
                            <i class="fas fa-satellite-dish"></i>
                          </span>

                          <span class="text-muted ml-3" v-if="marcacao.item_status.ultima_etapa && marcacao.item_status.ultima_etapa.id_etapa_atendimento == 7">
                            <span v-if="tem_arquivo(marcacao)">
                              <i class="fa fa-paperclip mr-2"></i>
                            </span>
                            <span v-if="tem_receita(marcacao)">
                              <i class="fas fa-prescription mr-2"></i>
                            </span>
                            <span v-if="tem_prescricao(marcacao)">
                              <i class="fas fa-pills mr-2"></i>
                            </span>
                            <span v-if="tem_requisicao(marcacao)">
                              <i class="fas fa-heartbeat mr-2"></i>
                            </span>
                            <span v-if="tem_atestado(marcacao)">
                              <i class="fa fa-plus mr-2"></i>
                            </span>
                          </span>

                          <span v-if="paciente && paciente.nps && ( marcacao.in_nps_score || marcacao.in_nps_score === 0 )"
                            class="badge ml-3" :class="'badge-' + ( marcacao.in_nps_score < 7 ? 'danger' : ( marcacao.in_nps_score < 9 ? 'warning' : 'success' ) )">
                            <i class="fa-solid fa-star mr-1"></i> {{ marcacao.in_nps_score }}
                          </span>
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="text-right">
                          <div>
                            <span v-if="marcacao.infusao && marcacao.in_qt_ciclo" class="mr-2" title="Ciclo / Dia">
                                C{{ marcacao.in_qt_ciclo }} / D{{ marcacao.in_qt_dia }}
                                <i class="fa-solid fa-arrows-spin fa-fw ml-1"></i>
                            </span>

                            <span v-if="marcacao.st_regiao" class="badge badge-secondary mr-2">
                              {{ marcacao.st_regiao }}
                            </span>

                            <a href="#" @click.prevent="abrirAtendimentoNaRecepcao(marcacao)" v-if="na_recepcao && marcacao && marcacao.id_atendimento && marcacao.ch_estado_marcacao != 'C'" 
                              title="Visualizar Atendimento">
                              <i class="fas fa-play-circle"></i>
                            </a>
                            <a href="#" @click.prevent="retornarAoAtendimento(marcacao.atendimento)"
                              v-if="marcacao.atendimento 
                                && marcacao.atendimento.pode_alterar_prontuario
                                && ( marcacao.item_status.valor != 'atendido' || !marcacao.item_status.na_recepcao )
                                && ( marcacao.medico.id_pessoa == $store.state.user.id_pessoa || $store.state.user.delegantes_medicos.find(del => del.delegante.id_pessoa == marcacao.medico.id_pessoa) )"
                              class="card-link">
                              {{ marcacao.procedimento.search }}
                            </a>
                            <a href="#" class="card-link" v-else-if="marcacao.atendimento && marcacao.atendimento.fl_avulso && marcacao.atendimento.avulso && marcacao.atendimento.avulso.fl_no_pep && marcacao.atendimento.avulso.id_usuario == $store.state.user.id_usuario"
                              @click.prevent="abrir_avulso(marcacao.atendimento)">
                              {{ marcacao.procedimento.search }}
                            </a>
                            <span v-else>
                              {{ marcacao.procedimento.search }}
                            </span>
                            <span v-if="marcacao.procedimento.id_classe_procedimento == 1 && marcacao.ch_tipo_consulta == 'R'" title="Revisão">
                              <i class="fas fa-registered text-danger ml-1" aria-hidden="true"></i>
                            </span>
                            <span v-if="marcacao.atendimento && marcacao.atendimento.fl_avulso" data-toggle="tooltip" data-placement="left" 
                              title="Registro Avulso. Sem registro de marcação/atendimento.">
                              <i class="fas fa-plus-circle ml-2 text-muted"></i>
                            </span>
                          </div>
                          <small>
                            <span class="text-muted mr-3" v-if="marcacao.plano">
                              {{ marcacao.plano.search }}
                            </span>

                            <span class="text-muted mr-3" v-if="marcacao.id_atendimento">
                              <a href="#" @click.prevent="abrir_atendimento(marcacao.id_atendimento)" class="card-link"> 
                                #{{ marcacao.id_atendimento }}
                              </a>
                            </span>

                            {{ marcacao.medico.st_nome_exibicao }}
                          </small>
                        </div>
                        <div v-if="$store.state.user.medico && marcacao.atendimento && marcacao.medico.id_pessoa == $store.state.user.id_pessoa && tem_doc_certificado(marcacao.atendimento)">
                          <button type="button" class="btn btn-sm btn-outline-secondary ml-2" @click="compartilhar(marcacao.atendimento)">
                            <i class="fa fa-share" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="card-body" v-show="!marcacao.resumido">

                        <div class="small text-muted mb-2" v-if="marcacao.atendimento && marcacao.atendimento.avulso && marcacao.atendimento.avulso.fl_no_pep && marcacao.atendimento.avulso.usuario">
                          Registrado por {{ marcacao.atendimento.avulso.usuario.st_login }}
                        </div>

                        <div class="alert alert-danger" v-if="marcacao.ch_estado_marcacao == 'C'">
                          <div class="small text-muted">{{ $util.getFormatDate(marcacao.dt_cancelamento) }}</div>
                          <strong>Motivo Cancelamento:</strong> 
                          {{ marcacao.st_motivo_cancelamento }}

                          <template v-if="marcacao.st_observacoes">
                            <hr>
                            <span style="white-space: pre-wrap;">{{ marcacao.st_observacoes }}</span>
                          </template>
                        </div>

                        <div v-if="marcacao.item_status && marcacao.item_status.valor == 'nao-compareceu'" class="alert alert-secondary">
                            Não Compareceu
                        </div>

                        <template v-if="listMode == 'C'">
                          <div v-if="!marcacao.id_atendimento">
                            Paciente Agendado.
                          </div>

                          <div v-else-if="marcacao.atendimento && marcacao.atendimento.atendimento_procedimentos">

                            <div class="d-flex justify-content-between mb-3">
                              <strong v-if="marcacao.plano">{{ marcacao.plano.search }}</strong>
                              <div v-if="marcacao.atendimento.atendimento_procedimentos.length > 1">
                                <span class="badge badge-secondary">
                                  {{ marcacao.atendimento.atendimento_procedimentos.length }}
                                </span>
                              </div>
                            </div>

                            <table class="table table-hover table-sm mb-0">
                              <tbody>
                                <tr v-for="(atp, iax) in marcacao.atendimento && marcacao.atendimento.atendimento_procedimentos" :key="iax">
                                  <td width="80%">
                                    {{ atp.procedimento.search }}
                                    <span class="badge badge-secondary ml-2" v-if="atp.in_quantidade > 1">
                                      x{{ atp.in_quantidade}}
                                    </span>
                                  </td>
                                  <td class="text-right">
                                    <span class="badge badge-success" v-if="atp.plano_particular">
                                      {{ atp.plano_particular.search }}
                                    </span>
                                    <span title="Senha de autorização informada" v-else>
                                      <i class="fa fa-check-circle text-success" aria-hidden="true" v-if="atp.st_codigo_autorizacao"></i>
                                    </span>
                                  </td>
                                  <td class="text-right" v-if="ver_valores">
                                    {{ $util.formatMoeda(atp.cd_valor_total) }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </template>

                        <template v-else>

                          <div :class="( model_print == 'N' && !marcacao.id_atendimento ) ? 'd-print-none' : ''">

                            <div class="small text-muted mb-3" v-if="model_print != 'N' && marcacao.atendimento && marcacao.atendimento.atendimento_procedimentos && ( marcacao.atendimento.atendimento_procedimentos.length > 1 || marcacao.atendimento.atendimento_procedimentos.find(atp => atp.canc || atp.st_codigo_autorizacao) )">
                              <span v-for="(atp, iax) in agrupar_procedimentos(marcacao)" :key="iax">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true" v-if="iax"></i>
                                <span class="badge badge-secondary" v-if="atp.qtd > 1">{{ atp.qtd }}</span>
                                <s v-if="atp.canc">{{ atp.proc }}</s>
                                <span v-else>{{ atp.proc }}</span>
                                <span class="badge badge-secondary ml-1" v-if="atp.regiao">{{ atp.regiao }}</span>
                                <span class="badge badge-light" v-if="atp.senha">{{ atp.senha }}</span>
                              </span>                 
                            </div>

                            <!-- Pré Atendimento -->
                            <pre-atendimento-view :marcacao="marcacao" />

                          </div>
                          
                          <!-- Paciente agendado -->
                          <template v-if="marcacao.item_status.valor == 'agendado'">
                            <div v-if="marcacao.outros_proc_lista" class="small text-muted mb-3">
                              <span class="badge badge-primary mr-2">
                                <i class="fa fa-plus mr-1" aria-hidden="true"></i>
                                {{ marcacao.outros_proc }}
                              </span>
                              {{ marcacao.outros_proc_lista }}
                            </div>

                            <div v-if="marcacao.autorizacao && marcacao.autorizacao.status_solicitacao" class="d-flex flex-column">
                                <a href="#" @click.prevent="abrir_solic_aut(marcacao.autorizacao)" class="badge mb-3" :class="'badge-' + marcacao.autorizacao.status_solicitacao.color">
                                    Autorização: {{ marcacao.autorizacao.status_solicitacao.msg }}

                                    <span class="ml-3">
                                        <i class="fa-solid fa-stamp ml-1"></i>
                                        {{ marcacao.autorizacao.id_solicitacao_autorizacao }}
                                    </span>
                                </a>
                            </div>

                            <span class="d-flex justify-content-between align-items-center">
                              <div class="d-flex align-items-center">
                                <i class="far fa-calendar-alt fa-3x mr-3 text-primary" data-toggle="tooltip" data-placement="top" title="Atendimento Agendado"></i>

                                <!-- Marcação com Recorrências -->
                                <template v-if="marcacao.repeticao && marcacao.recorrencias">
                                    <div> 
                                        <span class="dropdown">
                                            <button class="btn btn-outline-primary mr-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Remarcar
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <a class="dropdown-item" href="#" @click.prevent="$util.remarcar(marcacao, { blockrepetir: false })">Remarcar Todas as Datas</a>
                                                <a class="dropdown-item" href="#" @click.prevent="$util.remarcar({ id_marcacao: marcacao.id_marcacao }, { blockrepetir: true })">Remarcar Apenas {{ $util.getFormatDate(marcacao.dt_inicio) }}</a>
                                            </div>
                                        </span>
                                    </div>
                                </template>

                                <template v-else>
                                    <button type="button" class="btn btn-outline-primary mr-2" @click="$util.remarcar(marcacao)">Remarcar</button>
                                </template>

                                <button type="button" class="btn btn-outline-primary mr-2" @click="editar_marcacao(marcacao)">Editar</button>
                                <button type="button" class="btn btn-outline-danger mr-2" @click="cancelar_marcacao(marcacao)">Cancelar</button>
                                
                                <button
                                  type="button"
                                  class="btn btn-outline-primary mr-2"
                                  @click="confirmar(marcacao)"
                                >Confirmar</button>
                                <button
                                  v-if="marcacao.dt_inicio.substr(0,10) == $util.hoje() && marcacao.id_medico == $store.state.user.id_pessoa && pode_atender"
                                  type="button"
                                  class="btn btn-outline-success mr-2"
                                  @click="registrarAtendimento(marcacao)"
                                >Atender</button>
                                <h4>
                                  <span class="ml-3 badge badge-danger" v-if="marcacao.ch_estado_marcacao == 'B'">
                                    <i class="fa fa-ban mr-2" aria-hidden="true"></i>
                                    Agenda Bloqueada
                                  </span>
                                </h4>
                              </div>
                              <div v-if="marcacao.repeticao" class="text-right">
                                <div> 
                                  <i class="fas fa-sync-alt mr-1"></i>
                                  <span class="badge badge-secondary ml-1" v-for="(dia, idiax) in marcacao.dias" :key="idiax">
                                    {{ dia }}
                                  </span>
                                </div>
                                <div> 
                                  <span class="dropdown" v-for="(rec, id_marcacao, irecx) in marcacao.recorrencias" :key="irecx">
                                    <button class="btn btn-primary btn-sm p-1 ml-1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      {{ $util.getFormatDate(rec) }}
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item disabled" href="#" @click.prevent>{{ $util.getFormatDate(rec) }} {{ rec.slice(11,16) }}</a>  
                                        <a class="dropdown-item" href="#" @click.prevent="$util.remarcar({ id_marcacao: id_marcacao }, { blockrepetir: false })">Remarcar recorrência a partir dessa</a>
                                        <a class="dropdown-item" href="#" @click.prevent="$util.remarcar({ id_marcacao: id_marcacao }, { blockrepetir: true })">Remarcar somente essa</a>
                                        <a class="dropdown-item" href="#" @click.prevent="editar_marcacao({ id_marcacao: id_marcacao })">Editar</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item text-danger" href="#" @click.prevent="cancelar_marcacao({ id_marcacao: id_marcacao })">Cancelar</a>
                                    </div>
                                  </span>
                                  <template v-if="false">
                                    <hr>
                                    <span class="badge badge-primary ml-1" v-for="(rec, irecx) in marcacao.recorrencias" :key="irecx">
                                      {{ $util.getFormatDate(rec) }}
                                    </span>
                                  </template>
                                </div>
                              </div>
                            </span>
                          </template>

                          <!-- Paciente Agendado, mas faltou -->
                          <span v-else-if="marcacao.item_status.valor == 'bloqueado'" class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                              <i class="far fa-calendar-alt fa-3x mr-3 text-primary" data-toggle="tooltip" data-placement="top" title="Atendimento Agendado"></i>
                              <template v-if="!historico">
                                <button type="button" class="btn btn-outline-primary mr-2" @click="$util.remarcar(marcacao)">
                                  Remarcar
                                </button>
                                <button type="button" class="btn btn-outline-danger mr-2" @click="cancelar_marcacao(marcacao)">
                                  Cancelar
                                </button>
                              </template>
                            </div>
                          </span>

                          <!-- Paciente Agendado, mas faltou -->
                          <span v-else-if="marcacao.item_status.valor == 'faltoso'" class="d-flex align-items-center justify-content-between">
                            <span>
                                <i class="far fa-calendar-times fa-3x mr-3 text-danger" data-toggle="tooltip" data-placement="top" title="Falta no Agendamento"></i>
                                <span>Falta no Agendamento</span>
                            </span>
                            <span>
                                <button type="button" class="btn btn-outline-primary" @click="$util.remarcar(marcacao)">
                                  Remarcar
                                </button>
                            </span>
                          </span>

                          <!-- Paciente chamado -->
                          <span v-else-if="marcacao.item_status.ultima_etapa && marcacao.item_status.ultima_etapa.id_etapa_atendimento == 5">
                            <button type="button" class="btn btn-success" @click="iniciarAtendimento(marcacao)">
                              <i class="fas fa-play mr-2" v-if="!$store.state.loading"></i>
                              <div class="spinner-border spinner-border-sm" role="status" v-else>
                                <span class="sr-only">Loading...</span>
                              </div>
                              Iniciar Atendimento
                            </button>
                          </span>

                          <!-- Paciente chamado -->
                          <span v-else-if="marcacao.item_status.ultima_etapa 
                              && ( !marcacao.recepcao || !marcacao.recepcao.fl_emergencia )
                              && ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 6 || marcacao.item_status.ultima_etapa.id_etapa_atendimento == 15 )
                              && ( !( marcacao.atendimento && marcacao.atendimento.atendimento_procedimentos && marcacao.atendimento.atendimento_procedimentos[0] && marcacao.atendimento.atendimento_procedimentos[0].laudo ) )">
                            <template v-if="marcacao.id_medico == $store.state.user.id_pessoa">
                              <template v-if="marcacao.dt_inicio.substr(0,10) < $util.hoje()">
                                <div class="alert alert-warning">Atendimento não finalizado.</div>
                                <button type="button" class="btn btn-danger" @click="retornarAoAtendimento(marcacao.atendimento)">
                                  <i class="fas fa-play mr-2"></i>
                                  Acessar Atendimento para Finalização
                                </button>
                              </template>
                              <button type="button" class="btn btn-success" @click="retornarAoAtendimento(marcacao.atendimento)" v-else>
                                <i class="fas fa-play mr-2"></i>
                                Retornar ao Atendimento
                              </button>
                            </template>
                            <template v-else>
                              <div class="alert alert-warning mb-0">Atendimento não finalizado.</div>
                            </template>
                          </span>

                          <!-- Paciente atendido na recepção, aguardando ser chamado -->
                          <span v-else-if="marcacao.item_status.valor == 'atendido'" class="d-flex align-items-center">

                            <template v-if="marcacao.item_status.na_recepcao">

                              <i class="fas fa-user-friends fa-3x mr-3 text-warning"></i>
                              <button type="button" class="btn btn-outline-warning" @click="info_na_recepcao()">
                                Na Recepção
                              </button>
                              
                            </template>
                            
                            <template v-else>
                              <i class="far fa-bell fa-3x mr-3 text-success" data-toggle="tooltip" data-placement="top" title="Atendimento realizado na recepção"></i>
                              <button 
                                type="button" 
                                class="btn btn-outline-success mr-2" 
                                :disabled="$store.state.loading || ( marcacao.id_medico != $store.state.user.id_pessoa && 
                                    !( marcacao.medico && marcacao.medico.fl_agenda_compartilhada && $store.state.user.medico ) )" 
                                @click="chamar(marcacao)">
                                Chamar Paciente
                              </button>
                            </template>

                          </span>

                          <!-- Paciente atendido. Registro do prontuário -->
                          <span v-else-if="marcacao.item_status.ultima_etapa && ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 7 || ( marcacao.recepcao && marcacao.recepcao.fl_emergencia ) )">

                            <div v-if="marcacao.atendimento && marcacao.atendimento.cid" class="small border-bottom" :class="model_print == 'N' ? 'd-print-none' : ''">
                              CID: {{ marcacao.atendimento.cid.st_codigo }}
                            </div>
                            
                            <div v-for="(atdp, ida) in marcacao.atendimento.atendimento_procedimentos" :key="'a' + idx + '-' + ida">
                                <span v-if="atdp.anamnese"> <!-- && atdp.anamnese.st_anamnese -->

                                    <!-- Anamnese -->
                                    <div v-if="atdp.anamnese.st_anamnese 
                                        && !atdp.laudo
                                        && ( atdp.anamnese.dados == '@' 
                                        || !atdp.anamnese.dados
                                        || atdp.anamnese.dados.length != 1 
                                        || atdp.anamnese.dados[0].type != 'textarea'
                                        || atdp.anamnese.dados[0].value )" class="alert alert-light border-dark">
                                        <div class="mb-3" v-if="atdp.anamnese.dados == '@'">
                                            <span v-html="atdp.anamnese.st_anamnese" />
                                        </div>
                                        <formulario
                                            v-else 
                                            v-model="atdp.anamnese.dados" 
                                            mode="view" 
                                            :show_hide="true"
                                            :tamanho="tamanho" 
                                            :imprimindo="imprimindo"
                                            :view_with_print="model_print != 'N'" 
                                            secundario2="marcacao.id_procedimento != atdp.id_procedimento" 
                                            :secundario="marcacao.id_procedimento != atdp.id_procedimento || ( marcacao.atendimento.registros && marcacao.atendimento.registros.length )" 
                                            :modelo_prontuario="atdp.anamnese.modelo_prontuario"
                                            @imprimirAnamnese="imprimirAnamnese(atdp.anamnese)">
                                            <template v-slot:botoes>
                                                <button type="button" class="btn btn-link btn-sm ml-2 text-secondary" @click="$util.logAudit('anamnese', atdp.anamnese.id_anamnese)" v-if="$store.state.user.id_usuario == 1">
                                                    <i class="fa fa-question" aria-hidden="true"></i>
                                                </button>
                                            </template>
                                        </formulario>
                                    </div>

                                    <span v-else-if="marcacao.id_procedimento == atdp.id_procedimento">
                                        Atendimento realizado
                                    </span>

                                    <div :class="model_print == 'N' ? 'd-print-none' : ''">
                                        <template v-if="!ida">
                                            <div v-if="marcacao.infusao" class="alert alert-info d-flex justify-content-between mt-3"> 
                                                <div>
                                                    {{ marcacao.infusao.st_titulo }} 
                                                    <span class="badge badge-secondary ml-2" v-if="marcacao.in_qt_dia">D{{ marcacao.in_qt_dia }}</span>
                                                </div>
                                                <a href="#" @click.prevent="consultar_contatos('App\\azure\\receita', marcacao.infusao.protocolo.receita.id_receita)" v-if="marcacao.infusao && marcacao.infusao.protocolo && marcacao.infusao.protocolo.receita && marcacao.infusao.protocolo.receita.contato">
                                                    <span class="badge" :class="'badge-' + marcacao.infusao.protocolo.receita.contato.contato_status.st_color">
                                                        {{ marcacao.infusao.protocolo.receita.contato.contato_status.search }}
                                                        / {{ $util.getFormatDate(marcacao.infusao.protocolo.receita.contato.created_at, 'DD/MM') }}
                                                    </span>
                                                </a>
                                                <div v-if="marcacao.in_qt_ciclo && marcacao.infusao.ciclos">
                                                    <i class="fa-solid fa-arrows-spin mr-2"></i>
                                                    {{ marcacao.in_qt_ciclo }}/{{ marcacao.infusao.ciclos }}
                                                </div>
                                            </div>

                                            <!-- Order Sets -->
                                            <order-set-view :dados="atdp.anamnese.receita" :tamanho="tamanho" type="receita" :imprimindo="imprimindo" />
                                            <order-set-view :dados="atdp.anamnese.requisicao" :tamanho="tamanho" type="requisicao" :imprimindo="imprimindo" />
                                        </template>

                                        <!-- Documentos -->
                                        <div v-if="atdp.anamnese.documentos && atdp.anamnese.documentos.length">
                                            <a href="#" class="text-white" @click.prevent="abrir_doc_view(doc)"
                                            v-for="(doc, iax) in atdp.anamnese.documentos" :key="iax" target="_blank">
                                            <span class="badge badge-warning p-2 mr-2 mb-2">
                                                <i class="far fa-file-alt mr-2"></i>
                                                {{ doc.st_titulo }}  
                                            </span>
                                            </a>
                                        </div> 

                                        <template v-if="!ida">
                                            <!-- Atestados -->
                                            <div v-for="(atest, ida) in atdp.anamnese.atestados" :key="'atest' + ida">
                                                <atestado-view :atest="atest"
                                                :view_only="true"
                                                :atendimento="marcacao.atendimento"
                                                :key="'atest' + ida" />
                                            </div>
                                            
                                            <!-- Anexos -->
                                            <div v-if="atdp.anamnese.arquivos && atdp.anamnese.arquivos.length">
                                                <a :href="arq.arquivo.temporary_url" class="text-white"
                                                    v-for="(arq, iax) in atdp.anamnese.arquivos" :key="iax" target="_blank">
                                                    <span class="badge badge-primary p-2 mr-2 mb-2">
                                                        <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                                                        {{ arq.arquivo.st_titulo }}  
                                                    </span>
                                                </a>
                                            </div>
                                        </template>
                                    </div>
                                </span>

                                <span v-else-if="marcacao.id_procedimento == atdp.id_procedimento">
                                    Atendimento realizado
                                
                                    <!-- Documentos -->
                                    <div v-if="atdp.anamnese && atdp.anamnese.documentos && atdp.anamnese.documentos.length" class="mt-3">
                                        <a href="#" class="text-white" @click.prevent="abrir_doc_view(doc)"
                                            v-for="(doc, iax) in atdp.anamnese.documentos" :key="iax" target="_blank">
                                            <span class="badge badge-warning p-2 mr-2 mb-1">
                                                <i class="far fa-file-alt mr-2"></i>
                                                {{ doc.st_titulo }}  
                                            </span>
                                        </a>
                                    </div> 
                                </span>

                            </div>

                          </span>
                          <span v-else-if="marcacao.item_status.valor == 'concluido'" class="lead">
                            <span v-if="!( marcacao.atendimento 
                                && marcacao.atendimento.atendimento_procedimentos 
                                && marcacao.atendimento.atendimento_procedimentos.find(item => item.laudo && item.laudo.id_status_laudo != 1 ) )">
                                Atendimento não finalizado.
                            </span>
                          </span>

                          <template v-if="marcacao.atendimento && marcacao.atendimento.amostras_klis_count">
                                <div>
                                    <span v-for="(atdp, iax) in marcacao.atendimento.atendimento_procedimentos.filter(atdp => atdp.laudo)" :key="iax" class="badge badge-pill badge-primary mr-1">
                                        {{ atdp.procedimento.st_sigla ? atdp.procedimento.st_sigla : atdp.procedimento.st_procedimento }}
                                    </span>
                                </div>

                                <div>
                                    <button type="button" class="btn btn-outline-primary btn-sm d-print-none mt-3" @click="verificar_resultado_klis(marcacao)" :disabled="$store.state.loading">
                                        <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="$store.state.loading"></span>
                                        <i class="fa fa-search mr-2" aria-hidden="true" v-else></i>
                                        Verificar Resultados
                                    </button>

                                    <div class="mt-3" v-if="marcacao.laudo_klis && marcacao.laudo_klis.resultados && marcacao.laudo_klis.resultados.html">
                                        <span v-html="marcacao.laudo_klis.resultados.html"></span>
                                    </div>
                                </div>
                          </template>
                          
                          <template v-if="marcacao.atendimento">
                            <template v-for="(atdp, ida) in marcacao.atendimento.atendimento_procedimentos">
                              <div :key="'a' + idx + '-' + ida" v-if="atdp.laudo && atdp.laudo.status_laudo && ( atdp.laudo.status_laudo.fl_pronto || atdp.laudo.arquivos.length )">

                                <div class="alert d-flex justify-content-between mt-3" :class="atdp.fl_ativo ? 'alert-info' : 'alert-danger'">
                                    <span>{{ atdp.procedimento.search }}</span>
                                    <div>
                                        <url-estudo-pacs v-if="pode_abrir_pacs(marcacao, atdp)"
                                            :id_atendimento_procedimento="atdp.id_atendimento_procedimento"
                                            :id_paciente="marcacao.atendimento.id_paciente">
                                        </url-estudo-pacs>
                                        <span class="badge badge-danger" v-if="!atdp.fl_ativo">Atendimento Cancelado</span>
                                        <span v-if="atdp.laudo && atdp.laudo.doc_certificado">
                                            <a :href="atdp.laudo.doc_certificado.arquivo.temporary_url" target="_blank" class="ml-2">
                                                <i class="fa-solid fa-file-contract"></i>
                                            </a>
                                        </span>

                                        <div>
                                            <span class="badge badge-danger" v-if="!atdp.fl_ativo">Atendimento Cancelado</span>
                                            <span v-if="atdp.laudo && atdp.laudo.doc_certificado">
                                                <a :href="atdp.laudo.doc_certificado.arquivo.temporary_url" target="_blank" class="ml-2" v-if="false">
                                                    <i class="fa-solid fa-file-contract"></i>
                                                </a>

                                                <a href="#" @click.prevent="abrir_laudo_jpg(atdp.laudo.doc_certificado.arquivo)" target="_blank" class="ml-2 card-link" title="Baixar Laudo em JPG"
                                                    v-if="( marcacao && marcacao.plano && marcacao.plano.operadora && marcacao.plano.operadora.fl_sus ) 
                                                    || ( paciente && paciente.paciente_unidade && paciente.paciente_unidade.st_sus )">
                                                    jpg
                                                </a>  
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <template v-if="!atdp.laudo.status_laudo.fl_pronto">
                                    <span class="badge h5 mb-3" :class="'badge-' + atdp.laudo.status_laudo.st_color">
                                        {{ atdp.laudo.status_laudo.search }}
                                    </span>

                                    <div>
                                        <a :href="arq.arquivo.temporary_url" class="btn btn-outline-secondary mr-1" target="_blank" v-for="(arq, iax) in atdp.laudo.arquivos" :key="iax">
                                            <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                                            {{ ( arq.arquivo && arq.arquivo.st_titulo ) ? arq.arquivo.st_titulo : 'Anexo' }}
                                        </a>
                                    </div>
                                </template>

                                <template v-else>
                                    <template v-if="atdp.laudo && atdp.laudo.arquivos && atdp.laudo.arquivos.length">
                                        <visualizar-laudo-externo :atp="atdp" />
                                    </template>

                                    <template v-if="atdp.laudo.arquivos && atdp.laudo.arquivos.filter(arq => arq.st_tipo_especial != 'anexo').length">
                                        <!-- 
                                        <a :href="arq.arquivo.temporary_url" class="btn btn-outline-primary mr-1" target="_blank" v-for="(arq, iax) in atdp.laudo.arquivos" :key="iax">
                                            <i class="fa fa-print mr-2" aria-hidden="true"></i>
                                            Visualizar Laudo
                                        </a>
                                        -->
                                    </template>
                                    <template v-else-if="atdp.laudo.st_laudo">
                                        <span v-if="atdp.laudo.fl_html && atdp.laudo.st_layout_impressao" v-html="atdp.laudo.st_layout_impressao"></span>
                                        <span>
                                            <template v-if="atdp.laudo.partes && atdp.laudo.partes.length">
                                                <div v-for="(registro, iregx) in atdp.laudo.partes" :key="iregx">
                                                    <campos-formulario 
                                                        v-model="registro.st_conteudo" 
                                                        :raiz="true" 
                                                        mode="view"
                                                        :compact="false" />
                                                </div>
                                            </template>

                                            <span v-else-if="atdp.laudo.fl_html && !atdp.laudo.st_layout_impressao && atdp.laudo.st_laudo" v-html="atdp.laudo.st_laudo"></span>

                                            <formulario
                                                v-else-if="!atdp.laudo.fl_unificar"
                                                v-model="atdp.laudo.dados" 
                                                mode="view" 
                                                :secundario="marcacao.id_procedimento != atdp.id_procedimento" 
                                                :view_with_print="model_print != 'N'" 
                                                :imprimindo="imprimindo"
                                                :modelo_prontuario="atdp.laudo.modelo_prontuario"
                                                @imprimirAnamnese="imprimir_laudo(atdp.laudo.id_laudo)">
                                                <template v-slot:botoes>
                                                    <button type="button" class="btn btn-link btn-sm ml-2 text-secondary" @click="$util.logAudit('laudo', atdp.laudo.id_laudo)" v-if="$store.state.user.id_usuario == 1">
                                                        <i class="fa fa-question" aria-hidden="true"></i>
                                                    </button>
                                                </template>
                                            </formulario>
                                        </span>
                                        <div v-if="false">
                                            <a :href="arq.arquivo.temporary_url" class="btn btn-outline-secondary mr-1" target="_blank" v-for="(arq, iax) in atdp.laudo.arquivos" :key="iax">
                                                <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                                                {{ ( arq.arquivo && arq.arquivo.st_titulo ) ? arq.arquivo.st_titulo : 'Anexo' }}
                                            </a>
                                        </div>
                                    </template>

                                    <!-- Arquivos do Laudo -->
                                    <template v-if="atdp.laudo && atdp.laudo.arquivos && atdp.laudo.arquivos.length">

                                        <div class="alert alert-primary d-flex justify-content-between mt-3" v-if="atdp.laudo.arquivos && atdp.laudo.arquivos.length">
                                            <div>
                                                {{ atdp.laudo.arquivos.length }} arquivo(s)
                                            </div>

                                            <div>
                                                <a href="#" @click.prevent="toggle_ver_anexos_laudo(atdp)">
                                                <i class="fa-solid fa-eye-slash fa-fw" v-if="!atdp.laudo.ver_anexos"></i>
                                                <i class="fa-solid fa-eye fa-fw" v-else></i>
                                                </a>
                                            </div>
                                        </div>

                                        <ver-arquivos-rolagem :arquivos="atdp.laudo.arquivos" v-if="atdp.laudo.ver_anexos" />

                                    </template>

                                </template>
                              </div>
                            </template>

                            <template v-if="marcacao.atendimento.registros && marcacao.atendimento.registros.length">
                              <div v-for="(registro, iregx) in marcacao.atendimento.registros" :key="iregx">
                                  <div v-if="registro.st_conteudo && registro.st_conteudo.length">
                                      <az-sub-title :title="titulo_registro(registro)">
                                      </az-sub-title>

                                      <campos-formulario 
                                          v-model="registro.st_conteudo" 
                                          :raiz="true" 
                                          mode="view"
                                          :compact="registro.modelo.fl_compact" />
                                  </div>
                              </div>
                            </template>
                          </template>

                          <div v-if="marcacao.arquivos.length">
                            <az-sub-title class="mt-3" title="Anexos do Atendimento" />
                            <a :href="arq.arquivo.temporary_url" class="text-white"
                              v-for="(arq, iax) in marcacao.arquivos" :key="iax" target="_blank">
                              <span class="badge badge-primary p-2 mr-2 mb-2">
                                <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                                {{ arq.arquivo.st_titulo }}  
                              </span>
                            </a>
                          </div>

                          <div v-if="marcacao.doc_receps && marcacao.doc_receps.length">
                                <az-sub-title class="mt-3" title="Documentos Recepção" />
                                <a href="#" class="text-white" v-for="(docr, iax) in marcacao.doc_receps" :key="iax" @click.prevent="abrir_doc_view(docr)">
                                    <span class="badge badge-info p-2 mr-2 mb-2">
                                        <i class="far fa-file-alt mr-2"></i>
                                        {{ docr.st_titulo }}  
                                    </span>
                                </a>
                          </div>

                        </template>

                      </div>

                    </div>
                  </div>

                </td>

              </tr>

            </template>

        <tr v-if="pagina > 0">
          <td>
            <button type="button" class="btn btn-sm btn-outline-primary my-2" @click="load(pagina ? pagina : 1)">Carregar mais... ({{ pagina }})</button>
          </td>
        </tr>

        <tr>
          <td>

            <!-- Legado -->
            <div class="card" v-for="(item, idx) in lista_legado" :key="'l' + idx" style="padding: 0px;">
              <div class="card-header d-flex justify-content-between alert-primary">
                <div>
                  <div>
                    <a class="card-link" href="#" role="button" @click.prevent="item.resumido = !item.resumido">
                      <i class="far fa-calendar-alt mr-2"></i>
                      {{ getHumanDate(item.dt_data) }} |
                      <span>{{ getHumanDay(item.dt_data) }}</span> |
                      <small>{{ getHumanDuration(item.dt_data) }}</small>
                    </a>
                  </div>
                  <div>
                    <i class="fas fa-history mr-2"></i>
                    <small>{{ item.dt_data.substr(11,5) }}</small>
                  </div>
                </div>
                <div class="text-right">
                  <div>{{ item.st_descricao }}</div>
                  <small>{{ item.st_nome_medico }}</small>
                </div>
              </div>

              <div>
                <div class="card-body pt-1" v-show="!item.resumido">

                  <div class="text-right">
                    <url-estudo-pacs v-if="pode_abrir_pacs_legado(item)"
                        :accession_number="item.st_an">
                    </url-estudo-pacs>
                    <!-- <button @click.prevent="open_url_estudo_legado(item)" v-if="pode_abrir_pacs_legado(item)" type="button" class="btn btn-link btn-sm ml-2 text-success">
                        <i class="fas fa-x-ray text-primary"
                            data-toggle="tooltip" data-placement="top" title="Visualizar Imagens do PACS" />
                    </button> -->
                    <button @click.prevent="imprimirLegado(item.id_prontuario_legado)" type="button" class="btn btn-link btn-sm ml-2 text-success">
                        <i class="fas fa-print" @click="$emit('imprimirAnamnese', value)"></i>
                    </button>

                  </div>

                    <p v-if="item.st_observacao" class="alert alert-secondary py-2 small d-flex justify-content-between align-items-center">
                      <span>{{ item.st_observacao }}</span>
                    </p>
                  <div>

                    <template v-if="item.st_tipo && item.st_tipo == 77 && item.form">

                        <campos-formulario 
                            :gutters="item.modelo ? item.modelo.fl_espaco_reduzido : false"
                            :tamanho="tamanho"
                            v-model="item.form" 
                            :modelo="item.modelo"
                            :raiz="true" 
                            mode="view" />

                        <template v-if="item.html">
                        <span v-html="item.html" class="lead legadoitem"></span>
                        </template>

                    </template>

                    <template v-else> 
                        <span v-html="item.st_conteudo" class="lead legadoitem"></span>
                    </template>

                  </div>

                  <!-- Anexos -->
                  <div v-if="item.arquivos">
                    <a href="#" @click.prevent="enviar_arquivo(item, 'prontuarioLegado', 'id_prontuario_legado')" class="card-link m-0 mr-3">
                      <span data-toggle2="tooltip" data-placement="top" title="Anexar Arquivos">
                        <i class="fa fa-paperclip ml-2" aria-hidden="true" 
                          v-if="item && item.arquivos && item.arquivos.length"></i>
                        <i class="fas fa-plus ml-2" v-else></i>
                      </span>
                    </a>

                    <template v-if="item.arquivos.length">

                      <span v-for="(arq, iax) in item.arquivos" :key="iax">
                        <a :href="arq.arquivo.temporary_url" class="text-white" :key="iax" target="_blank">
                          <span class="badge badge-primary p-2 mr-2 mb-2">
                            <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                            {{ arq.arquivo.st_titulo }}  
                          </span>
                        </a>
                        <a href="#" class="btn btn-outline-danger btn-sm" :key="iax + 'r'" v-if="$store.state.user.id_usuario == 1"
                          @click.prevent="remover_anexo(arq)">
                          <i class="fa fa-times" aria-hidden="true"></i>
                        </a>
                      </span>

                    </template>
                  </div>
                </div>

                <div class="card-footer" v-if="model_print == 'N' && $store.state.user.id_usuario == 1">
                  <button type="button" class="btn btn-outline-secondary btn-sm" @click="enviar_arquivo(item, 'prontuarioLegado', 'id_prontuario_legado')">
                    Anexar
                  </button>
                </div>

              </div>
            </div>

              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- Cancelar Marcação -->
      <cancelar-marcacao ref="canc_atd_pep" @cancelado="load(false)" modalName="cancAtdPepModal" />

      <!-- Modal -->
      <div
        class="modal fade"
        id="detailModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5
                class="modal-title"
                id="exampleModalLabel"
              >{{ atendimento.atendimento_procedimento ? atendimento.atendimento_procedimento.procedimento.st_procedimento : '' }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              {{ atendimento.atendimento_procedimento && atendimento.atendimento_procedimento.anamnese ?
              atendimento.atendimento_procedimento.anamnese.st_anamnese : '' }}
              <pre>{{ atendimento }}</pre>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      
      <!-- Upload de Arquivo para o Legado -->
      <template v-if="anexo.id">
        <az-file-upload
          ref="upload_pl"
          :multiple="true"
          @refresh="refresh_arquivos"
          :arquivos="anexo.arquivos"
          :parms="{ 
            model_type: anexo.model, 
            model_id: anexo.id,
            fechar_ao_enviar: true  
          }" />
      </template>

    </div>

    <!-- Iniciar Atendimento -->
    <iniciar-atendimento ref="ini_atd_consultorio" v-if="atender" @refresh="load(false)" />

    <!-- Resultados -->
    <resultados ref="resultados" name="pep" block="1" />

    <!-- Compartilhar -->
    <compartilhar-docs ref="compartilhardocs" v-if="$store.state.user.medico" />

    <!-- Galeria de Imagems -->
    <gallery-preview ref="galleryperfil" :emmodal="true" />

    <!-- Visualização de Documentos -->
    <div class="modal fade" :id="'docViewModal' + modal_chave" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content" v-if="doc">
          <div class="modal-header">
            <h5 class="modal-title">{{ doc.st_titulo }}</h5>
              <button type="button" class="close" @click="fechar_modal('docViewModal' + modal_chave)" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <doc-view :view="true" :doc="doc" />

          </div>
          <div class="modal-footer" v-if="doc">
            <a href="#" @click.prevent="abrir_laudo_jpg(doc.doc_certificado.id_arquivo, true)" target="_blank" class="mr-1 btn btn-info" title="Baixar Laudo em JPG"
              v-if="doc && doc.doc_certificado && doc.doc_certificado.id_arquivo">
              Download Imagem
            </a>  
            <a :href="doc.doc_certificado.arquivo.temporary_url" target="_blank" class="btn btn-primary" v-if="doc.doc_certificado && doc.doc_certificado.arquivo" title="Documento Certificado.">
              <i class="fa-solid fa-file-contract"></i> 
            </a>
            <az-submit @click="$util.print_preview('imprimir/documento/' + doc.id_documento_atendimento, true)" v-if="doc.fl_ativo && doc.id_documento_atendimento">
              Imprimir 
            </az-submit>
            <az-submit @click="$util.print_preview('imprimir/documento_recepcao/' + doc.id_documento_recepcao, true)" v-else-if="doc.fl_ativo && doc.id_documento_recepcao">
              Imprimir 
            </az-submit>
            <button type="button" class="btn btn-secondary" @click="fechar_modal('docViewModal' + modal_chave)">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Selecionar Profissional Modal -->
    <div class="modal fade" id="avulsoSelecaoMedicoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Selecionar Profissional</h5>
              <button type="button" class="close" @click="fechar_modal('avulsoSelecaoMedicoModal')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body" v-if="dthr_avulso">

            <div class="row">
                <div class="col col-12">
                    <az-input
                        class="mb-2"
                        icon="fa-solid fa-credit-card fa-fw"
                        type="autocomplete" 
                        optionsMode="aql"
                        optionsName="planos.atendimento"
                        :optionsParm="{
                            atendimento: true,
                            plano_id_unidade_operacao: id_unidade_operacao_avulso
                        }"
                        service="planos.index"
                        :optionsSync="false"
                        placeholder="Selecione a Operadora/Plano..."
                        required
                        :validate="validate"    
                        v-model="avulso_plano" />
                </div>
            </div>

            <div class="row">
              <div class="col col-12">
                <az-input 
                  class="mb-2"
                  icon="far fa-calendar-plus fa-fw"
                  type="datetime-local"
                  required
                  :validate="validate"
                  v-model="dthr_avulso" />
              </div>
            </div>

            <div class="row">
              <div class="col col-12">
                <az-input
                  placeholder="Selecionar Profissional"
                  icon="fas fa-user-md fa-fw"
                  type="select"
                  optionsMode="aql"
                  service="medicos.index"
                  optionsName="medicos-lista-avulso"
                  optionsData="id_pessoa"
                  :optionsParm="{ ativos: true, sem_agenda_compartilhada: true }"
                  required
                  :validate="validate"
                  v-model="id_medico_avulso" />
              </div>
            </div>

            <br><br><br><br><br><br><br><br>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="fechar_modal('avulsoSelecaoMedicoModal')">Cancelar</button>
            <az-submit @click="salvar_avulso()">Selecionar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Registro Avulso -->
    <div class="modal fade" id="registroAvulsoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content" v-if="procedimentos_avulso">
          <div class="modal-header">
            <h5 class="modal-title">Selecione o Procedimento</h5>
              <button type="button" class="close" @click="fechar_modal_avulso()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="row">
                <div class="col col-12">
                    <az-input
                        class="mb-2"
                        icon="fa-solid fa-credit-card fa-fw"
                        type="autocomplete" 
                        optionsMode="aql"
                        optionsName="planos.atendimento"
                        :optionsParm="{
                            atendimento: true,
                            plano_id_unidade_operacao: id_unidade_operacao_avulso
                        }"
                        service="planos.index"
                        :optionsSync="false"
                        placeholder="Selecione a Operadora/Plano..."
                        required
                        :validate="validate"    
                        v-model="avulso_plano" />
                </div>
            </div>

            <template v-if="delegantes">
              <div class="small text-muted">Em nome de...</div>
              <div class="list-group">
                <button type="button" class="list-group-item list-group-item-action" v-for="(deleg, idx) in delegantes" :key="idx" @click="novo_atendimento_avulso(deleg.delegante.id_pessoa)">
                  {{ deleg.delegante.search }}
                </button>
              </div>
            </template>

            <template v-else>
              <az-input 
                class="mb-2"
                icon="far fa-calendar-plus fa-fw"
                type="datetime-local"
                required
                :validate="validate"
                v-model="dthr_avulso" />
            
              <az-input
                class="mb-2"
                v-if="!$store.state.user.id_unidade_operacao"
                icon="fa fa-building fa-fw"
                type="select"
                placeholder="Selecione a Unidade..."
                :optionsList="$util.unidades_com_tags(false, true)"
                optionsData="id_unidade_operacao"
                required
                :validate="validate"    
                v-model="id_unidade_operacao_avulso">
              </az-input>

              <az-input
                class="mb-2"
                icon="fa fa-search fa-fw"
                v-model="search_avulso" />

              <div class="list-group">
                <button type="button" class="list-group-item list-group-item-action" v-for="(proc, ipx) in lista_procedimentos_avulsos" :key="ipx"
                  @click="salvar_avulso(proc)" :disabled="incluindo_avulso">
                  {{ proc.search }}
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Filtrar Período PEP -->
    <div class="modal fade" id="filrarPeriodoPepModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Período</h5>
              <button type="button" class="close" @click="fechar_modal('filrarPeriodoPepModal')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col col-12">
                <az-input
                  type="date"
                  label="De"
                  v-model="filtro_periodo.dt_inicio" />
              </div>
            </div>

            <div class="row">
              <div class="col col-12">
                <az-input
                  type="date"
                  label="Até"
                  v-model="filtro_periodo.dt_fim" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="fechar_modal('filrarPeriodoPepModal')">Cancelar</button>
            <button type="button" class="btn btn-success" @click="aplicar_filtro_periodo()">Filtrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Filtro por Modelo de Prontuário -->
    <div class="modal fade" id="selecModeloProntModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content" v-if="selec_model">
          <div class="modal-header">
            <h5 class="modal-title">Seleção do Modelo</h5>
              <button type="button" class="close" @click="fechar_modal('selecModeloProntModal')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="list-group">
              <button type="button" class="list-group-item list-group-item-action" @click="selecao_modelo()">TODOS</button>
              <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" v-for="(modelo, imx) in lista_modelos" :key="imx" @click="selecao_modelo(modelo)">
                <span>{{ modelo.st_modelo_prontuario }}</span>
                <span class="badge badge-secondary">#{{ modelo.id_modelo_prontuario }}</span>
              </button>
            </div>          
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="fechar_modal('selecModeloProntModal')">Cancelar</button>
          </div>
        </div>
      </div>
    </div>

    <registrar-contatos ref="contatos" titulo="Validação" @refresh="$emit('refresh')" />

    <pep-view-receitas ref="viewreceitas" />

    <validar-codigo-atendimento ref="valcode" />

  </div>
</template>

<script>
import _ from "lodash";
import * as moment from "moment";
import $ from "jquery";
import FichaPaciente from "../../shared/FichaPaciente.vue";
import Formulario from "./Formulario.vue";
import OrderSetView from "./OrderSetView.vue";
import AtestadoView from './AtestadoView.vue';
import AzEmptyState from "../../util/AzEmptyState.vue";
import AzSubmit from '../../util/AzSubmit.vue';
import CancelarMarcacao from "../callcenter/CancelarMarcacao.vue";
import LembretePaciente from "./LembretePaciente.vue";
import IniciarAtendimento from "../recepcao/IniciarAtendimento.vue";
import AzLoading from '../../util/AzLoading.vue';
import Resultados from './Resultados.vue';
import AzFileUpload from "../../util/AzFileUpload.vue";
import AzSubTitle from '../../util/AzSubTitle.vue';
import PreAtendimentoView from './PreAtendimentoView.vue';
import CompartilharDocs from './CompartilharDocs.vue';
import GalleryPreview from '../../shared/gallery/GalleryPreview.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import HistoricoPacotesPaciente from '../../shared/HistoricoPacotesPaciente.vue';
import HistoricoMarcacoes from '../callcenter/HistoricoMarcacoes.vue';
import DocView from './DocView.vue';
import PepSideBar from './PepSideBar';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import CamposFormulario from './CamposFormulario.vue';
import ListaRetornos from '../../shared/ListaRetornos.vue';
import ListaOrcamentos from './ListaOrcamentos.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import PepViewReceitas from './PepViewReceitas.vue';
import ValidarCodigoAtendimento from './ValidarCodigoAtendimento.vue';
import UrlEstudoPacs from "../pacs/UrlEstudoPacs.vue";
import VerArquivosRolagem from './VerArquivosRolagem.vue';
import VisualizarLaudoExterno from "./VisualizarLaudoExterno.vue";

export default {
  data() {
    return {
      tamanho: 'M',
      paciente: {},
      atendimentos: [],
      atendimento: {},
      marcacoes: null,
      nome: "",
      loading: true,
      search: "",
      lista: null,
      search_timeout: null,
      cancelar: false,
      pode_atender: false,
      atender: false, 
      local: "", 
      legado: [],
      lista_legado: [],
      rechamado: false,
      resultados: [], 
      id_anexar_prontuario_legado: null, 
      incluindo_avulso: false, 
      expandido: true, 
      procedimentos_avulso: null,
      search_avulso: "", 
      dthr_avulso: "",
      id_unidade_operacao_avulso: "", 
      avulso_plano: "", 
      validate: false, 
      doc: null, 
      listMode: 'L',
      anexo: { 
        model: "",
        id: -1,
        arquivos: [], 
      },
      model_print: 'C', 
      imprimindo: false, 
      autorizacoes: [], 
      retornos: [], 
      tipo_filtro: "", 
      verificando_resultado: false, 
      ver_valores: false, 
      filtro_periodo: { 
        dt_inicio: "",
        dt_fim: "",
      },
      filtro_periodo_aplicado: null, 
      id_medico_delegante: null, 
      delegantes: null, 
      historico: false,
      info_fila: null, 
      tem_paginacao: false, 
      pagina: 0, 
      pode_avulso: false, 
      id_medico_avulso: "", 
      local_item: "", 
      id_modelo_prontuario: "", 
      selec_model: false, 
      modelo_pront_selecionado: null, 
      validar_codigo: false, 
      modal_chave: "", 
      exibir_agendados: false, 
    };
  },
  props: ["id", "tmp", "panel", "fila", "temporario", "block_foto", "id_atend"],
  components: {
    FichaPaciente,
    Formulario,
    OrderSetView,
    AzEmptyState,
    CancelarMarcacao,
    LembretePaciente,
    IniciarAtendimento,
    AzLoading,
    Resultados,
    AzFileUpload,
    AzSubTitle,
    PreAtendimentoView,
    CompartilharDocs, 
    GalleryPreview, 
    AzInput, 
    HistoricoPacotesPaciente,
    DocView, 
    AzSubmit, 
    PepSideBar,
    CabecalhoGenerico,
    CamposFormulario,
    HistoricoMarcacoes, 
    ListaRetornos, 
    AtestadoView, 
    ListaOrcamentos,
    RegistrarContatos, 
    PepViewReceitas, 
    ValidarCodigoAtendimento,
    UrlEstudoPacs, 
    VerArquivosRolagem, 
    VisualizarLaudoExterno
  },

  computed: {
    qt_agendados: function () { 
        if ( !this.marcacoes )
            return 0;
    
        return this.marcacoes.filter(item => item.item_status && item.item_status.valor == 'agendado').length;
    },

    lista_modelos: function () { 
      if ( !this.lista )
        return [];

      let lista_atps = this.lista.flatMap(marcacao => { 
            if ( marcacao.atendimento && marcacao.atendimento.atendimento_procedimentos ) { 
              return marcacao.atendimento.atendimento_procedimentos.map(atp => { 
                if ( atp.anamnese && atp.anamnese.modelo_prontuario ) { 
                  return atp.anamnese.modelo_prontuario;
                } else if ( atp.laudo && atp.laudo.modelo_prontuario ) { 
                  return atp.laudo.modelo_prontuario;
                }

                return;
              });
            }

            return [];
          })
          .filter(item => item);

      let lista_regs = this.lista.flatMap(marcacao => { 
            if ( marcacao.atendimento && marcacao.atendimento.registros ) { 
              return marcacao.atendimento.registros.map(reg => reg.modelo)
            }  
            
            return [];
          })
          .filter(item => item);

      return _.orderBy(
        _.uniqBy(
          lista_atps.concat(lista_regs),
          'id_modelo_prontuario'
        ),
        'st_modelo_prontuario'
      );
    },

    lista_locais: function() { 
      if ( this.local && this.local.indexOf('|') > 0 ) { 
        return this.local.split('|')
          .map(loc => { 
            return { 
              id: loc.trim(),
              search: loc.trim() 
            };
          });
      }

      return [];
    },

    is_labs: function () { 
      return window.redir == 'labs' || window.redir == 'teste';
    },

    cookie_list_mode: function () { 
      return 'pep-list-mode-' + this.$store.state.user.id_usuario;
    },

    na_recepcao: function() { 
      return this.$route.path == '/recepcao';
    },

    telefones: function() {
      return !this.paciente.cadastro
        ? []
        : this.paciente.cadastro.telefone_cadastros.filter(item => {
            return item.telefone.st_numero.trim();
          });
    },

    marcacao_pra_chamar: function() {
      if ( !this.marcacoes )
        return;

      return this.marcacoes.find(
        item => ( ( this.id_atend && item.id_atendimento == this.id_atend ) || ( !this.id_atend && item.dt_inicio.substr(0,10) == this.$util.hoje() ) )
            && item.item_status 
            && ( 
                item.item_status.valor == 'chamado' || item.item_status.valor == 'chamado-pos' 
                || item.item_status.valor == 'nao-compareceu' 
                || ( item.item_status.valor == 'finalizado-pre' && this.info_fila && !this.info_fila.fl_pre_atendimento ) 
            )
      );
    },

    lista_procedimentos_avulsos: function() { 
      if ( !this.procedimentos_avulso )
        return [];

      let pesquisar = this.search_avulso.trim();
      let parts = pesquisar.replace(' ','.*');
      let match = parts;
      let reg = new RegExp(match, 'i');

      return this.procedimentos_avulso && this.procedimentos_avulso.length ? 
          this.procedimentos_avulso.filter (item => { 
              return ( !this.search_avulso || reg.test(JSON.stringify(item)) );
          }) : null;
    }

    
  },
  methods: {
    toggle_ver_anexos_laudo (item) { 
        item.laudo.ver_anexos = !item.laudo.ver_anexos;

        this.$forceUpdate();
    },

    is_image (arquivo) { 
        return arquivo.st_tipo_arquivo == 'png' || arquivo.st_tipo_arquivo == 'jpg' || arquivo.st_tipo_arquivo == 'jpeg';
    },

    verificar_resultado_klis (marcacao) { 
        this.$util.load(this, { 
            service: 'laudos',
            func: 'resultados_klis', 
            parms: { 
                id_atendimento: marcacao.id_atendimento, 
            },
            loadTo: res => { 
                if ( res.resultados && res.resultados.original ) { 
                    marcacao.laudo_klis = { resultados: 
                        { 
                            html: res.resultados.original
                        }
                    };
                } else { 
                    marcacao.laudo_klis = res;
                }
                
                this.$forceUpdate();
            }
        });
    },

    validarCodigoAtendimento() { 
        if ( !this.marcacao_pra_chamar ) { 
            alert('Marcação não identificada.');
            return;
        }

        this.$refs.valcode.abrir(this.marcacao_pra_chamar);
    },

    abrir_solic_aut(autorizacao) { 
        if ( !autorizacao ) { 
            return;
        }

        $('.modal').modal('hide');

        if ( this.$router.currentRoute.name == 'solic-autoriz' ) {
                
            this.$router.push({ name: "dashboard" });

            this.$nextTick(() => {
                this.$router.push({ 
                    name: 'solic-autoriz',
                    params: { 
                        aba: 'lista', 
                        id: autorizacao.id_solicitacao_autorizacao,
                    },
                });
            });
            
        } else { 
    
            this.$router.push({ 
                name: 'solic-autoriz',
                params: { 
                    aba: 'lista', 
                    id: autorizacao.id_solicitacao_autorizacao,
                },
            });

        }
    },

    resumo_medicamentos() { 
        this.$refs.viewreceitas.abrir(this.lista);
    },

    consultar_contatos (type, id) { 
      this.$refs.contatos.visualizar(type, id);
    },

    selecao_modelo (modelo = null) { 
      $('#selecModeloProntModal').modal('hide');

      this.tipo_filtro = ( modelo ? 'modelo' : null );
      this.selec_model = false;
      this.modelo_pront_selecionado = modelo;

      this.$nextTick(() => { 
        this.filtrar();

        if ( this.$refs.pepsidebar ) { 
          this.$refs.pepsidebar.selecionar(this.lista[0], 0, false);
        }
      });
    },

    pode_abrir_pacs(marcacao, atdp) {
        return marcacao &&
                atdp &&
                atdp.st_pacs === "OK";
    },

    pode_abrir_pacs_legado(item) {
        return item && item.st_an;
    },

    // open_url_estudo(marcacao, atdp) {
    //   const id_atendimento_procedimento = atdp.id_atendimento_procedimento;

    //   this.$util.load(this, {
    //     service: 'pep',
    //     func: 'dr_tis_url',
    //     parms: {
    //       id_atendimento_procedimento: id_atendimento_procedimento,
    //       id_paciente: marcacao.atendimento.id_paciente,
    //     },
    //     loadTo: (res) => {
    //       if (res && res.url) {
    //         window.open(res.url, '_blank').focus();
    //       }
    //     }
    //   });
    // },

    // open_url_estudo_legado(item) {
    //     if (!item || !item.st_an ) return;

    //     this.$util.load(this, {
    //         service: 'pep',
    //         func: 'dr_tis_url',
    //         parms: {
    //         accession_number: item.st_an
    //         },
    //         loadTo: (res) => {
    //         if (res && res.url) {
    //             window.open(res.url, '_blank').focus();
    //         }
    //         }
    //     });
    // },

    filtrar_modelo () { 
      this.selec_model = true; 

      this.$nextTick(() => { 
        $('#selecModeloProntModal').modal('show');
      });
    },

    abrir_avulso (atendimento) { 
      $('.modal').modal('hide');

      if ( this.$route.path.slice(0,7) == '/avulso') { 
          this.$router.push({ path: '/' })
            .then(() => { 
              this.$router.push({ path: '/avulso/' + ( atendimento.id_atendimento ) });
            });
      } else { 
        this.$router.push({ path: '/avulso/' + ( atendimento.id_atendimento ) });
      }
    },

    abrir_laudo_jpg (arquivo, id = false) { 
      this.$util.loadItem(this, { 
        service: 'laudos', 
        func: 'obter_laudo_jpg',
        parms: { 
          id_arquivo: id ? arquivo : arquivo.id_arquivo, 
        }
      })
      .then(res => { 

        if ( res.link ) { 

          // Create an anchor element
          const anchor = document.createElement('a');
          anchor.href = res.link;
          anchor.download = 'laudo-' + arquivo.id_arquivo + '.jpg';
          anchor.target = '_blank';
          
          document.body.appendChild(anchor);

          // Trigger the download by simulating a click
          anchor.click();

          // Remove the anchor from the document
          document.body.removeChild(anchor);
        }

        // console.log('jpg', res);

      });

    },

    abrir_pagamentos() {
      $('.modal').modal('hide');

      if ( this.$route.path == '/' ) { 
        if ( !this.paciente ) { 
          this.$router.push({ path: '/recepcao/pagamentos/' + ( this.temporario ? 'p' + this.temporario.id_cadastro_temporario : '' ) });
        } else { 
          this.$router.push({ path: '/recepcao/pagamentos/' + ( this.paciente.id_pessoa ) });
        }

        return;
      }

      this.$router.push({ path: '/' })
          .then(() => { 
            if ( !this.paciente ) { 
              this.$router.push({ path: '/recepcao/pagamentos/' + ( this.temporario ? 'p' + this.temporario.id_cadastro_temporario : '' ) });
            } else { 
              this.$router.push({ path: '/recepcao/pagamentos/' + ( this.paciente.id_pessoa ) });
            }
          });
    },
    
    aplicar_filtro_periodo () { 
      this.filtro_periodo_aplicado = _.cloneDeep(this.filtro_periodo);
      this.filtrar();

      $('#filrarPeriodoPepModal').modal('hide');
    },

    filtrar_periodo () { 
      $('#filrarPeriodoPepModal').modal('show');
    },

    baixar_resultados_labs () { 
      let primeiro;
      
      primeiro = this.lista ? this.lista.find(item => item.procedimento && item.procedimento.id_especialidade == 2 && item.st_id_externo && !isNaN(item.st_id_externo.slice(0,1))) : null;

      if ( !primeiro ) { 
        primeiro = this.lista ? this.lista.find(item => item.st_id_externo && !isNaN(item.st_id_externo.slice(0,1))) : null;
      }

      if ( primeiro ) { 
        this.verificando_resultado = true;

        this.$util.atualizar(this, { 
          service: 'pep', 
          func: 'obter_resultados_labs',
          dados: { 
            id_marcacao: primeiro.id_marcacao, 
          },
          toast: 'Verificação realizada',
          final: () => { 
            this.verificando_resultado = false;
            this.load(false);
          }
        });
      } else { 
        this.$toast.add({
          severity: 'warn',
          summary: "Atenção",
          detail: "Não há atendimento integrados para verificação.",
          life: 3000
        });
      }
    },

    confirmar (marcacao) { 
        $(".modal").modal('hide');

        if ( this.$route.path == '/call-center/confirmacao') { 
            this.$router.push({ path: '/' })
                .then(() => { 
                    this.$router.push({ name: 'confirmacao', params: { marcacao: marcacao } });
                });
        } else { 
            this.$router.push({ name: 'confirmacao', params: { marcacao: marcacao } });
        }
    },

    imprimir_laudo(laudo) {
      this.$util.print_preview('imprimir/laudo/' + laudo, true, { notAssign: 1 }, true);
    },

    abrir_atendimento (id) { 
      $('.modal').modal('hide');

      if ( this.$route.path == '/recepcao') { 
          this.$router.push({ path: '/' })
            .then(() => { 
              this.$util.abrir_atendimento(this, id);
            });
      } else { 
        this.$util.abrir_atendimento(this, id);
      }
    },

    info_na_recepcao () { 
      this.$toast.add({
        severity: 'warn',
        summary: "Chamar",
        detail: "Paciente em atendimento na recepção.",
        life: 3000
      });
    },

    adicionar_marcacao(item = null) { 
      $('[data-toggle="tooltip"]').tooltip("dispose");
      $('.modal').modal('hide');

      if ( item ) { 

        if ( this.$route.path == '/call-center') { 
          this.$router.push({ path: '/' })
            .then(() => { 
              this.$router.push({
                name: "call-center",
                params: { 
                  autorizacao: item.id_solicitacao_autorizacao,
                  outro_medico: item.medico ? false : true 
                },
              });      
            });
          return;
        }
        
        this.$router.push({
          name: "call-center",
          params: { 
            autorizacao: item.id_solicitacao_autorizacao,
            outro_medico: item.medico ? false : true  
          },
        });

      } else if ( this.paciente ) { 
        
        if ( this.$route.path == '/call-center') { 
          this.$router.push({ path: '/' })
            .then(() => { 
              this.$router.push({
                name: "call-center",
                params: { marcar_paciente: this.paciente.id_pessoa },
              });      
            });
          return;
        }
        
        this.$router.push({
          name: "call-center",
          params: { marcar_paciente: this.paciente.id_pessoa },
        });

      } else if ( this.marcacoes && this.marcacoes.length ) { 

        if ( this.$route.path == '/call-center') { 
          this.$router.push({ path: '/' })
            .then(() => { 
              this.$router.push({
                name: "call-center",
                params: { adicao: this.marcacoes[0].id_marcacao },
              });      
            });
          return;
        }

        this.$router.push({
          name: "call-center",
          params: { adicao: this.marcacoes[0].id_marcacao },
        });

      }
    },

    titulo_registro(registro) { 
      let conselho = "";

      if ( registro && registro.fl_consultorio ) { 
        return _.get(registro, 'modelo.st_modelo_prontuario');
      }

      if ( _.get(registro, 'usuario.medico.in_numero_conselho') ) { 
        conselho = _.get(registro, 'usuario.medico.conselho.st_sigla') 
          + ' '
          + _.get(registro, 'usuario.medico.in_numero_conselho')
          + ', ';
      }

      return _.get(registro, 'usuario.pessoa.st_nome') + ', ' + conselho + 
        ( !registro.created_at ? 'Novo' : this.$util.getFormatDate(registro.created_at) + ' ' + registro.created_at.substr(11,5) );
    },

    imprimir_agendas () { 

        let marcacao = this.marcacoes.find(item => item.ch_estado_marcacao == 'A');

        if ( marcacao ) { 
          this.$util.print_preview('imprimir/marcacoes/' + marcacao.id_marcacao, true);
        } else { 
          this.$toast.add({
            severity: 'warn',
            summary: "Atenção",
            detail: "Não há atendimento agendado.",
            life: 3000
          });
        }

    },
    
    imprimir(tipo = 'C') { 
      this.imprimindo = true;
      this.model_print = tipo;

      this.$nextTick(() => { 
        this.$htmlToPaper('impressao-historico', null, () => {
          console.log("Printing");
          this.model_print = 'C';
          this.imprimindo = false;
        });
      });
    },

    agrupar_procedimentos(marcacao) { 
      let lista = _.map(
            _.groupBy(marcacao.atendimento.atendimento_procedimentos, item => { 
              return item.id_procedimento + '-' + item.fl_ativo + ' - ' + item.st_regiao;
            }),
            (itens) => { 
              return { 
                canc: !_.find(itens, item => item.fl_ativo), 
                qtd: _.sumBy(itens, 'in_quantidade'),
                proc: _.first(itens).procedimento.search, 
                regiao: _.first(itens).st_regiao, 
                senha: _.uniq(
                  itens.filter(item => item.st_codigo_autorizacao).map(item => item.st_codigo_autorizacao)
                ).join(', '),
              };
            }
          );

      lista = _.orderBy(lista, 'proc');

      return lista;
    },
    imprimirAnamnese(anamnese) {
      if ( anamnese.doc_certificado ) { 
        this.$util.print_preview('imprimir/doc_certificado/anamnese/' + anamnese.id_anamnese, true);
      } else { 
        this.$util.print_preview('imprimir/anamnese/' + anamnese.id_anamnese, true);
      }
    },

    imprimirLegado(id_prontuario_legado) {
      this.$util.print_preview('imprimir/legado/' + id_prontuario_legado, true);
    },
        
    toggle_modo_view (tipo = null) { 
      $('[data-toggle="tooltip"]').tooltip("dispose");
      this.listMode = ( tipo ? tipo : this.listMode == 'S' ? 'L' : 'S' );
      this.$util.setCookie(this.cookie_list_mode, this.listMode);
    },

    definir_tamanho_fonte (tamanho) { 
      this.tamanho = tamanho;
      this.$util.setCookie('tamanho-fonte-pep', this.tamanho);
    },

    abrirAtendimentoNaRecepcao (marcacao) { 
      $('.modal').modal('hide');
      this.$root.$children[0].$refs.modulo.iniciar(marcacao, 1);
    },

    abrir_galeria_imagens(anexos = false) { 
      this.$refs.galleryperfil.abrir({ id_paciente: this.id, anexos: anexos });
    },

    tem_modelo (marcacao) { 
      if ( !this.modelo_pront_selecionado ) { 
        return true;
      }

      let teste = marcacao.atendimento.atendimento_procedimentos.find(item => ( item.anamnese && item.anamnese.id_modelo_prontuario == this.modelo_pront_selecionado.id_modelo_prontuario )
        || ( item.laudo && item.laudo.id_modelo_prontuario == this.modelo_pront_selecionado.id_modelo_prontuario ));
        
      if ( teste ) 
        return true; 

      if ( marcacao.atendimento.registros ) { 
        
        teste = marcacao.atendimento.registros.find(item => ( item.id_modelo_prontuario == this.modelo_pront_selecionado.id_modelo_prontuario ));

        if ( teste ) 
          return true; 

      }
      
      return false;
    },

    tem_receita (marcacao) { 
      // return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.receita && item.anamnese.receita.length) ? true : false;
      return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.tem_receita) ? true : false;
    },

    tem_prescricao (marcacao) { 
      // return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.receita && item.anamnese.receita.length) ? true : false;
      return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.tem_prescricao) ? true : false;
    },

    tem_documento (marcacao) { 
      return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.documentos && item.anamnese.documentos.length) ? true : false;
    },

    tem_requisicao (marcacao) { 
      return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.requisicao && item.anamnese.requisicao.length) ? true : false;
    },

    tem_arquivo (marcacao) { 
      return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.arquivos && item.anamnese.arquivos.length) ? true : false;
    },

    tem_atestado (marcacao) { 
      return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.atestados && item.anamnese.atestados.length) ? true : false;
    },

    tour() { 
      window.scrollTo(0,0);

      // Define the tour!
      var tour = {
          id: "hello-hopscotch",
          i18n: { 
                  doneBtn: "Pronto",
                  nextBtn: "Próximo",
                  prevBtn: "Anterior",
                  skipBtn: "Pular"
              },
          steps: [
              {
                  title: "Pesquisar",
                  content: "Utilize esse campo para realizar pesquisas por palavra chave no histórico do paciente. É possível buscar pelo nome do procedimento, especialidade, nome de medicamento ou qualquer palavra que esteja presente no histórico.",
                  target: "pep-pesquisa",
                  placement: "bottom"
              },
              {
                  title: "Lembrete",
                  content: "Registro de lembrete vinculado ao paciente. Exibido na recepção e no consultório.",
                  target: "botao-lembrete-perfil",
                  placement: "left"
              },
              {
                  title: "Galeria de Imagens",
                  content: "Galeria de imagens do paciente. Permite visualização e comparação de imagens.",
                  target: "botao-galeria-de-imagens-perfil",
                  placement: "left"
              },
              {
                  title: "Resultados",
                  content: "Utilize esse botão para visualizar a planilha de histórico de resultados do paciente.",
                  target: "pep-ver-resultados",
                  placement: "left"
              },
              {
                  title: "Registro Avulso",
                  content: "Inclusão de atendimento avulso para o paciente.",
                  target: "pep-novo-atendimento",
                  placement: "left"
              },
              {
                  title: "Visualização",
                  content: "Este botão deve ser utilizado para definir se a visualização do histórico será detalhada, ou apenas da lista de atendimentos.",
                  target: "pep-detalhes",
                  placement: "left"
              },
              {
                  title: "Chamar Novamente",
                  content: "Ao clicar nesse botão, o aviso da chamada será enviada novamente para o painel de chamada.",
                  target: "pep-chamar-novamente",
                  placement: "bottom"
              },
              {
                  title: "Iniciar Atendimento",
                  content: "Ao clicar nesse botão, o atendimento do paciente será iniciado.",
                  target: "pep-iniciar-atendimento",
                  placement: "bottom"
              },

          ]
      };

      window.hopscotch.startTour(tour);

    },

    tem_doc_certificado(atendimento) {

      if ( !atendimento )
        return false;

      if ( atendimento.atendimento_procedimentos.findIndex(atp => {

        if ( atp.anamnese ) { 

          if ( atp.anamnese.receita && atp.anamnese.receita.findIndex(item => {
            return !!item.doc_certificado;
          }) >= 0 ) { 
            return true;
          } 

          if ( atp.anamnese.requisicao && atp.anamnese.requisicao.findIndex(item => {
            return !!item.doc_certificado;
          }) >= 0 ) { 
            return true;
          } 

        }

        return false;
        
      }) >= 0 ) { 
        return true;
      }

      return false;

    },

    compartilhar(atendimento) { 
      this.$refs.compartilhardocs.compartilhar(atendimento.id_atendimento);
    },

    toggle_expandir(selec = null) { 
      $('[data-toggle="tooltip"]').tooltip("dispose");
      this.expandido = ( selec === null ? !this.expandido : selec );
      this.$util.setCookie('pep-comprimido', !this.expandido);

      this.$nextTick(() => { 
        this.lista.forEach(item => {
          item.resumido = !this.expandido;
        });
  
        this.lista_legado.forEach(item => {
          item.resumido = !this.expandido;
        });
      });
    },

    abrir_doc_view(doc) { 
        this.doc = doc;

        if ( this.doc && this.doc.doc_certificado && this.doc.doc_certificado !== false ) { 
            this.$util.loadItem(this, { 
                service: 'documentos',
                func: 'show',
                parms: { 
                    id: this.doc.id_documento_atendimento,
                    cert: true, 
                }
            })
            .then(res => { 
                this.doc.doc_certificado = ( res && res.doc_certificado ) ? res.doc_certificado : false;
            });
        }

        $('#docViewModal' + this.modal_chave).modal('show');
    },

    fechar_modal_avulso() { 
      $('#registroAvulsoModal').modal('hide');
    },

    fechar_modal(modal) { 
      $('#' + modal).modal('hide');
    },

    salvar_avulso(proc) {

      this.incluindo_avulso = true;

      this.$util.atualizar(this, { 
        service: 'pep',
        func: 'incluir_avulso',
        dados: { 
          id_paciente: this.id,
          id_procedimento: proc ? proc.id_procedimento: null, 
          id_plano: this.avulso_plano ? this.avulso_plano.id_plano : null,
          data: this.dthr_avulso, 
          id_medico_delegante: this.id_medico_delegante, 
          id_medico_avulso: this.id_medico_avulso, 
          id_unidade_operacao: ( !this.$store.state.user.id_unidade_operacao && this.id_unidade_operacao_avulso ) 
            ? this.id_unidade_operacao_avulso 
            : this.$util.getCookie('id_unidade_operacao'),
        },
        callback: res => { 
          this.incluindo_avulso = false;
          
          if ( this.id_medico_avulso ) {
            //$('#avulsoSelecaoMedicoModal').modal('hide'); 
            // this.load();
            $(".modal").modal("hide");
            this.$router.push({ path: "/avulso/" + res.id_atendimento });
            return; 
          } 

          $(".modal").modal("hide");

          if ( this.$route.path.substr(0,17) == '/consultorio/res/' ) { 
            this.$router.push({ name: "redir", params: { path: "/consultorio/res/" + res.id_atendimento } });
          } else { 
            this.$router.push({ path: "/consultorio/res/" + res.id_atendimento });
          }
        },
        final: () => { 
          this.incluindo_avulso = false;
        }
      });

    },

    novo_atendimento_avulso(id_medico_selecionado = null) { 
      this.validate = false;
      
      $('[data-toggle="tooltip"]').tooltip("dispose");

      let id_medico = this.$store.state.user.id_pessoa;

      if ( !this.$store.state.user.medico ) { 
        if ( this.$store.state.user.delegantes_medicos && this.$store.state.user.delegantes_medicos.length == 1) { 
          console.log(this.$store.state.user);
          let id_teste = _.get(this.$store.state.user.delegantes_medicos, '0.delegante.id_pessoa');

          if ( id_teste ) { 
            id_medico = id_teste;
          }
        } else if ( this.$store.state.user.delegantes_medicos && this.$store.state.user.delegantes_medicos.length > 1 ) { 

          if ( !id_medico_selecionado ) { 

            this.delegantes = this.$store.state.user.delegantes_medicos;
            this.procedimentos_avulso = [];

            $('#registroAvulsoModal').modal('show');

            return

          } else { 

            id_medico = id_medico_selecionado;
            this.id_medico_delegante = id_medico_selecionado;
            this.delegantes = null;

          }

        } else { 

          id_medico = -1; 

        }

      }

      this.incluindo_avulso = true;

      this.$util.loadItem(this, { 
        service: 'medico_procedimento_unidades',
        func: 'index',
        parms: { 
          id_medico: id_medico, 
          avulso: true, 
        }
      })
      .then(res => { 
        this.procedimentos_avulso = res;
        this.dthr_avulso = this.$util.hoje() + 'T' + this.$util.agora().substr(0,5);
        this.avulso_plano = _.get(this.paciente, 'paciente_unidade.plano'); 

        if ( res.length || id_medico < 0 ) { 

          this.procedimentos_avulso.unshift({
            id_procedimento: 1177,
            search: "REGISTRO AVULSO",
          });

          this.$nextTick(() => { 
            if ( id_medico < 0 ) { 
              $('#avulsoSelecaoMedicoModal').modal('show');              
            } else { 
              $('#registroAvulsoModal').modal('show');
            }
          });
        } else { 
          this.salvar_avulso();
        }
      })
      .finally(() => { 
        this.incluindo_avulso = false;
      });

    },

    enviar_arquivo(pl, model, chave) {

      this.anexo.model = model;
      this.anexo.id = _.get(pl, chave);
      this.anexo.arquivos = _.get(pl, 'arquivos');

      if ( !this.anexo.id ) { 
        alert('Chave não identificada (' + chave + ').');
        return;
      }

      // this.id_anexar_prontuario_legado = pl.id_prontuario_legado;

      this.$nextTick(() => { 
        this.$refs.upload_pl.abrir();
      });
    },

    remover_anexo(anexo) { 
      this.$util.atualizar(this, { 
        service: 'arquivos',
        func: 'destroy',
        dados: { 
            id: anexo.id_arquivo_link, 
        },
        callback: this.refresh_arquivos,
      })
    },

    refresh_arquivos () { 
      this.id_anexar_prontuario_legado = null;
      this.load();
    },

    ver_resultados () { 
      this.$refs.resultados.visuaizar(this.id);
    },

    chamarNovamente (marcacao) { 
      if ( this.lista_locais.length && !this.local_item ) { 
        this.$toast.add({ 
          severity: "warn",
          summary: "Atenção",
          detail: "Selecione o local da chamada: \n" + this.lista_locais.map(loc => loc.search).join("\n"),
          life: 5000      
        });

        return; 
      }

      this.rechamado = true;
      this.chamar(marcacao);
    },

    chamar (marcacao) { 

      this.$store.commit('loading', true);

      let query = { q: [
        { 
          name: "atendimentos.chamar",
          id: "chamada",
          parms: { 
            id: marcacao.atendimento.id_atendimento, 
            id_recepcao: this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null,
            local: this.local_item ? this.local_item : this.local,
            block_painel: this.$util.getCookie('nao-enviar-painel'), 
            pos_atend: marcacao.item_status.valor == 'chamado-pos' ? true: false, 
            fila: this.fila, 
          }
        }
      ]};

      this.axios.post('/aql?a=ratendimentos.chamar', query)
        .then(res => { 
          if ( res.data.chamada.status == 200 ) { 
            marcacao.item_status.ultima_etapa = res.data.chamada.data.etapa_atendimento;
            this.$store.commit('loading', false);

            const msg = res.data.chamada.data.msg ? res.data.chamada.data.msg.msg : "Chamada re-enviada.";
            const severity = res.data.chamada.data.msg && res.data.chamada.data.msg.status_code > 400 ? 'warn' : 'success';

            if ( this.rechamado ) { 
              this.$toast.add({
                severity: severity,
                summary: "Chamar",
                detail: msg,
                life: 3000
              });
            } else { 
              this.load(false);
            }
          }
        })
        .finally (() => { 
          this.$store.commit('loading', false);
        });

    },

    registrarAtendimento(item) { 

      this.$store.commit("loading", true);
      this.atender = true;

      console.log('item', item);

      this.$nextTick(() => { 

        let query = {
          q: [
            {
              name: "marcacoes.show",
              id: "item",
              parms: {
                id: item.id_marcacao,
                para_atendimento: true
              }
            }
          ]
        };
  
        this.axios
          .post("/aql", query)
          .then(res => {
            if (res.data.item.status == 200) {
              let marcacao = res.data.item.data;
              $('.modal').modal("hide");
              $('[data-toggle="tooltip"]').tooltip("dispose");

              if ( marcacao.direto ) { 

                this.$store.commit("loading", false);

                let id_uo = this.$util.getCookie('id_unidade_operacao');
                let id_rc = this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null;

                let recep = this.$util.recepcao();

                if ( recep ) { 
                  id_uo = recep.id_unidade_operacao;
                  id_rc = recep.id_recepcao;
                }
                
                this.$util.atualizar(this, { 
                  service: 'marcacoes',
                  func: 'cerimonial_checkin',
                  dados: { 
                    id_marcacao: marcacao.id_marcacao, 
                    id_unidade_operacao: id_uo,
                    id_recepcao: id_rc,
                    expresso: true, 
                    origem: 'consultorio',
                  },
                  toast: true, 
                  callback: res => { 
                    
                    if ( res && res.atendimento ) { 
                      // item.id_atendimento = res.atendimento.id_atendimento;
                      // item.atendimento = res.atendimento;
                    }

                    if ( res && res.expresso && res.atendimento ) { 
                      this.load(false);
                    }

                  }
                });

                return;

              }

              this.$refs.ini_atd_consultorio.abrir(marcacao, 1);
            }
          })
          .finally(() => {
            this.$store.commit("loading", false);
          });

      });

    },

    cancelar_marcacao(marcacao) {
      this.cancelar = true;

      this.$nextTick(() => {
        this.$refs.canc_atd_pep.cancelar(marcacao);
      });
    },

    editar_marcacao(marcacao) { 
      this.$root.editar_marcacao(marcacao.id_marcacao);
    },

    pesquisar() {
      this.$store.commit("loading", true);

      if (this.search_timeout) clearTimeout(this.search_timeout);

      this.search_timeout = setTimeout(() => {
        this.filtrar();
        this.search_timeout = null;
      }, 300);
    },

    definir_filtro(tipo = null) { 
      this.tipo_filtro = tipo;

      if ( !tipo ) { 
        this.modelo_pront_selecionado = null;
      }

      this.$nextTick(() => { 
        this.filtrar();
      });
    },

    filtrar() {
      let pesquisar = this.search.trim();
      let parts = pesquisar.replace(" ", ".*");
      /*let match = parts.reduce((total, item) => {
            return total + `.*${item}.*`;
        }, "" );*/
      let match = parts;
      let reg = new RegExp(match, "i");
      let items;
      let legado; 

      if (pesquisar) {
        items = this.marcacoes.filter(item => {
          return reg.test(JSON.stringify(item));
        });

        legado = this.legado.filter(item => {
          return reg.test(JSON.stringify(item));
        }); 
      } else {
        items = this.marcacoes;
        legado = this.legado ? this.legado : [];
      }

      if ( this.tipo_filtro ) { 
        
        legado = [];

        // ( !this.modelo_pront_selecionado ) && 
          
        items = items.filter(item => item.atendimento && 
          ( 
            ( this.tipo_filtro == 'receita' && this.tem_receita(item) )
            || ( this.tipo_filtro == 'requisicao' && this.tem_requisicao(item) )
            || ( this.tipo_filtro == 'documento' && this.tem_documento(item) )
            || ( this.tipo_filtro == 'modelo' && this.tem_modelo(item) ) 
            || ( this.tipo_filtro == 'atestado' && this.tem_atestado(item) )  
          )
        );

        // tem_arquivo(marcacao)
        // tem_atestado(marcacao)

      }

      if ( this.filtro_periodo_aplicado ) { 
        items = items.filter(item => { 
          return ( !this.filtro_periodo_aplicado.dt_inicio || item.dt_inicio.substr(0,10) >= this.filtro_periodo_aplicado.dt_inicio )
            && ( !this.filtro_periodo_aplicado.dt_fim || item.dt_inicio.substr(0,10) <= this.filtro_periodo_aplicado.dt_fim );
        });

        legado = legado.filter(item => { 
          return ( !this.filtro_periodo_aplicado.dt_inicio || item.dt_data.substr(0,10) >= this.filtro_periodo_aplicado.dt_inicio )
            && ( !this.filtro_periodo_aplicado.dt_fim || item.dt_data.substr(0,10) <= this.filtro_periodo_aplicado.dt_fim );
        });
      }

      if ( this.qt_agendados > 10 && !this.exibir_agendados ) { 
        items = items.filter(item => !item.item_status || ( item.item_status.valor != 'agendado' ) );
      }

      this.lista = _.cloneDeep(items);
      this.lista_legado = _.cloneDeep(legado);

      if ( this.tipo_filtro == 'modelo' && this.modelo_pront_selecionado ) { 
        this.lista = this.lista.map(item => { 
          if ( item.atendimento && item.atendimento.registros ) { 
            item.atendimento.registros = item.atendimento.registros.filter(reg => reg.id_modelo_prontuario == this.modelo_pront_selecionado.id_modelo_prontuario);
          }

          if ( item.atendimento && item.atendimento.atendimento_procedimentos ) { 
            item.atendimento.atendimento_procedimentos = item.atendimento.atendimento_procedimentos.filter(atp => ( atp.anamnese && atp.anamnese.id_modelo_prontuario == this.modelo_pront_selecionado.id_modelo_prontuario)
              || ( atp.laudo && atp.laudo.id_modelo_prontuario == this.modelo_pront_selecionado.id_modelo_prontuario))
              .map(atp => { 
                if ( atp.anamnese ) { 
                  atp.anamnese.receita = [];
                  atp.anamnese.requisicao = [];
                  atp.anamnese.documentos = [];
                  atp.anamnese.atestados = [];
                }

                return atp;
              });
          }

          return item;
        });
      }

      this.$store.commit("loading", false);

    },
    retornarAoAtendimento(atd) {
      $(".modal").modal("hide");

      if ( this.$route.meta.vacina ) { 

        this.$router.push({ path: "/vacina/atendimento/" + atd.id_atendimento + '/' + this.fila});

      } else if ( this.$route.meta.enfermagem && this.$route.meta.cc ) { 

        this.$router.push({ path: "/centro-cirurgico/atendimento/" + atd.id_atendimento + '/' + this.fila});

      } else if ( this.$route.meta.enfermagem ) { 

        if ( atd.atendimento 
          && ( ( atd.atendimento.id_medico == this.$store.state.user.id_pessoa ) || this.$util.is_usuario_delegado(atd.atendimento.id_medico) ) 
          && atd.atendimento.atendimento_procedimentos 
          && atd.atendimento.atendimento_procedimentos.length == 1 
          && atd.atendimento.atendimento_procedimentos[0].procedimento.id_classe_procedimento == 1 ) { 

          this.$router.push({ path: "/consultorio/res/" + atd.id_atendimento + '/' + this.fila });  
          return;

        }

        this.$router.push({ path: "/assistencia/atendimento/" + atd.id_atendimento + '/' + this.fila});

      } else { 

        if ( this.$route.path.substr(0,17) == '/consultorio/res/' ) { 
          if ( this.$route.params.id == atd.id_atendimento ) { 
            return;
          }

          this.$router.push({ name: "redir", params: { path: "/consultorio/res/" + atd.id_atendimento } });
        } else { 
          this.$router.push({ path: "/consultorio/res/" + atd.id_atendimento });
        }

      }
    },
    naoComparecer(atd) { 
      if ( !confirm('Confirma registrar o não comparecimento do paciente a chamada?') ) 
        return;

      this.$util.atualizar(this, { 
        service: 'atendimentos',
        func: 'pausar',
        dados: { 
          id: atd.id_atendimento, 
          nao_compareceu: true, 
          fila: this.fila, 
        },
        callback: () => { 
          if ( this.$route.meta.enfermagem ) { 
            this.$router.push({ path: "/assistencia/atend" });
          } else { 
            this.$router.push({ name: "consultorio" });
          }
        }
      });

    },

    iniciarAtendimento(atd) {
      this.$store.commit("loading", true);

      let query = {
        q: [
          {
            name: "atendimentos.iniciar",
            id: "iniciar",
            parms: { 
              id: atd.id_atendimento,
              fila: this.fila, 
            }
          }
        ]
      };

      this.axios
        .post("/aql", query)
        .then(res => {
          if (res.data.iniciar.status == 200) {
            if (res.data.iniciar.data.id_etapa_atendimento == 6 || res.data.iniciar.data.id_etapa_atendimento == 15) {
              this.$store.commit("loading", false);
              this.retornarAoAtendimento(atd);
            }
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    },
    reload_pac() { 

      let query = {
        q: [
          {
            name: "pacientes.show",
            id: "paciente",
            parms: { 
              id: this.$props.id, 
              pep: true, 
              with: [
                "atendimentoPacotes.unidade_operacao", 
                "logo.arquivo", 
                "arquivos",
                "terceiroLogin.terceiro:id_terceiro,st_sigla", 
                "portal_usuarios", 
              ] 
            }
          }
        ]
      };

      this.axios
        .post("/aql?a=rpacientes.show", query)
        .then(res => {
          this.paciente = res.data.paciente.data;
          
          if (!this.panel) {

            if ( this.$route.meta.vacina ) {
              this.$store.commit("setBreadcrumb", [
                { name: "Vacina", path: "/vacina" },
                { name: this.paciente.st_nome, path: "/vacina/atend/" }
              ]);
            } else if ( this.$route.meta.enfermagem && this.$route.meta.cc ) {
              this.$store.commit("setBreadcrumb", [
                { name: "Centro Cirúrgico", path: "/centro-cirurgico/marcacao" },
                { name: "Atendimento", path: "/centro-cirurgico/atendimento" },
                { name: this.paciente.st_nome, path: "/centro-cirurgico/atend/" }
              ]);
            } else if ( this.$route.meta.enfermagem ) {
              this.$store.commit("setBreadcrumb", [
                { name: "Assistência", path: "/assistencia/atend" },
                { name: this.paciente.st_nome, path: "/assistencia/atend/" }
              ]);
            } else { 
              this.$store.commit("setBreadcrumb", [
                { name: "Consultório", path: "/consultorio" },
                { name: this.paciente.st_nome, path: "/consultorio" }
              ]);
            }

          }
        });

    },
    load(pagina = 0) {
      this.$store.commit("loading", true);
      this.filtro_periodo.dt_inicio = "";
      this.filtro_periodo.dt_fim = "";
      this.filtro_periodo_aplicado = null;
      this.loading = true;

      if ( pagina > 0 ) { 
        //
      } else { 
        this.autorizacoes = [];
        this.retornos = [];
        this.orcs = [];
      }
      
      this.tem_paginacao = false;
      
      let query = { q: [] };

      if ( this.id ) { 

        if ( pagina > 0 ) { 

            query = {
                q: [
                    {
                        name: "marcacoes.index",
                        id: "marcacoes",
                        parms: { id_paciente: this.$props.id, fila: this.fila, panel: this.panel  }
                    },
                ]
            }; 

        } else { 

            query = {
                q: [
                    {
                        name: "pacientes.show",
                        id: "paciente",
                        parms: { 
                            id: this.$props.id,
                            pep: true,  
                            with: [
                                "atendimentoPacotes.unidade_operacao", 
                                "logo.arquivo", 
                                "arquivos", 
                                "terceiroLogin.terceiro:id_terceiro,st_sigla",
                                "portal_usuarios", 
                            ] 
                        }
                    },
                    {
                        name: "marcacoes.index",
                        id: "marcacoes",
                        parms: { id_paciente: this.$props.id, fila: this.fila, panel: this.panel  }
                    },
                    {
                        name: "usuarios.tem_permissao",
                        id: "direto",
                        parms: { id_acao: 8 }
                    },
                    {
                        name: "pep.legado",
                        id: "legado",
                        parms: { id_paciente: this.$props.id }
                    },
                    {
                        name: "pep.avulsos",
                        id: "avulsos",
                        parms: { id_paciente: this.$props.id }
                    },
                    {
                        name: "resultados.index",
                        id: "resultados",
                        parms: { id_paciente: this.$props.id }
                    },
                    {
                        name: "pacientes.retornos",
                        id: "retornos",
                        parms: { id_paciente: this.$props.id, previstos: true }
                    },
                    {
                        name: "solicitacao_autorizacoes.index",
                        id: "autorizacoes",
                        parms: { paciente: { id_pessoa: this.$props.id }, pep: true }
                    },
                    {
                        name: "usuarios.tem_permissao_acesso",
                        id: "ver_valores",
                        parms: { resource_id: 129, block_vazio: true }
                    },
                    { 
                        name: "fila_laudos.show",
                        id: "fila",
                        parms: { id: ( this.fila ? this.fila : -1 ) }
                    },
                    { 
                        name: "orcamentos.index",
                        id: "orcs",
                        parms: { id_paciente: this.$props.id, pep: true }, 
                    },
                    { 
                        name: "pep.pode_avulso",
                        id: "pode_avulso",
                        parms: { pep: true }, 
                    },
                    { 
                        name: "configuracoes.get",
                        id: "validar_codigo",
                        parms: { st_slug: 'chamada-atendimento-validar-codigo' }, 
                    }
                ]
            };
        }

      } else { 

        query = {
          q: [
            {
              name: "marcacoes.index",
              id: "marcacoes",
              parms: { id_cadastro_temporario: this.tmp }
            },
            {
              name: "usuarios.tem_permissao",
              id: "direto",
              parms: { id_acao: 8 }
            },
            { 
              name: "solicitacao_autorizacoes.index",
              id: "autorizacoes",
              parms: { paciente: { id_cadastro_temporario: this.tmp } }
            },
            {
              name: "usuarios.tem_permissao_acesso",
              id: "ver_valores",
              parms: { resource_id: 129 }
            },
          ]
        };

      }

      let add_page = ""; 

      if ( pagina > 0 ) { 
        query.page = pagina + 1; 
        add_page = "&page=" + ( query.page );
      }

      this.axios
        .post("/aql?a=pep.load" + add_page, query)
        .then(res => {
          if ( pagina > 0 ) { 

            this.marcacoes = this.marcacoes.concat(res.data.marcacoes.data);  

          } else { 
            this.marcacoes = res.data.marcacoes.data;
          
            this.pode_atender = res.data.direto.data.pode;

            this.ver_valores = res.data.ver_valores ? res.data.ver_valores.data.pode : false;

            this.paciente = res.data.paciente ? res.data.paciente.data : null;
            this.legado = res.data.legado ? res.data.legado.data : null;
            this.resultados = res.data.resultados ? res.data.resultados.data : null;
            this.retornos = ( res.data.retornos && res.data.retornos.data ) ? res.data.retornos.data.lista : null;
            this.info_fila = ( res.data.fila && res.data.fila.data ) ? res.data.fila.data : null;
            this.orcs = res.data.orcs ? res.data.orcs.data : null;

            this.$emit('refresh_pac', this.paciente);

          }

          if ( res.data.marcacoes && res.data.marcacoes.data && res.data.marcacoes.data.length > 0 ) { 
            if ( _.get(res.data.marcacoes.data, '0.tem_paginacao') ) { 
              this.pagina = pagina + 1;   
            } else { 
              this.pagina = 0;
            }
          } else { 
            this.pagina = 0;
          }

          if ( pagina > 0 ) { 

            this.marcacoes = _.orderBy(
              this.marcacoes,
              'dt_inicio',
              'desc'
            );

          } else { 

            if ( res.data.avulsos && res.data.avulsos.data.length ) { 
                this.marcacoes = _.orderBy(
                this.marcacoes.concat(res.data.avulsos.data),
                'dt_inicio',
                'desc'
                );
            }

            if ( res.data.autorizacoes && res.data.autorizacoes.data && res.data.autorizacoes.data.length ) { 
                this.autorizacoes = res.data.autorizacoes.data;
            }

            if ( res.data.pode_avulso && res.data.pode_avulso.data && res.data.pode_avulso.data.pode ) { 
                this.pode_avulso = true; 
            }

            if ( res.data.validar_codigo && res.data.validar_codigo.data && res.data.validar_codigo.data.st_valor && res.data.validar_codigo.data.st_valor !== '0' ) { 
                this.validar_codigo = true; 
            }

          }

          this.filtrar();

          this.$nextTick(() => { 
            if ( !this.expandido ) { 
              this.toggle_expandir(this.expandido);
            }
          });

          if (!this.panel) {
            if ( this.$route.meta.avulso ) {
              this.$store.commit("setBreadcrumb", [
                { name: "Avulso", path: "/" },
                { name: this.paciente.st_nome, path: "/" }
              ]);
            } else if ( this.$route.meta.vacina ) {
              this.$store.commit("setBreadcrumb", [
                { name: "Vacina", path: "/vacina" },
                { name: this.paciente.st_nome, path: "/vacina/atend/" }
              ]);
            } else if ( this.$route.meta.enfermagem && this.$route.meta.cc ) {
              this.$store.commit("setBreadcrumb", [
                { name: "Centro Cirúrgico", path: "/centro-cirurgico/marcacao" },
                { name: "Atendimento", path: "/centro-cirurgico/atendimento" },
                { name: this.paciente.st_nome, path: "/centro-cirurgicao/atend/" }
              ]);
            } else if ( this.$route.meta.enfermagem ) {
              this.$store.commit("setBreadcrumb", [
                { name: "Assistência", path: "/assistencia/atend" },
                { name: this.paciente.st_nome, path: "/assistencia/atend/" }
              ]);
            } else { 
              this.$store.commit("setBreadcrumb", [
                { name: "Consultório", path: "/consultorio" },
                { name: this.paciente.st_nome, path: "/consultorio" }
              ]);
            }
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
          this.loading = false;
        });
    },

    load_detail(atendimento) {
      this.$store.commit("loading", true);
      let query = {
        q: [
          {
            name: "atendimentos.show",
            id  : "item",
            parms: { id: atendimento.id_atendimento }
          }
        ]
      };
      this.axios
        .post("/aql", query)
        .then(res => {
          this.atendimento = res.data.item.data;
          $("#detailModal").modal("show");
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    },
    getHumanDay(date) {
      return moment(date, "YYYY-MM-DD").format("dddd");
    },
    getHumanDate(date) {
      return (
        moment(date, "YYYY-MM-DD").format("DD") +
        " de " +
        moment(date, "YYYY-MM-DD").format("MMMM") +
        (moment(date, "YYYY-MM-DD").format("YYYY") == new Date().getFullYear()
          ? ""
          : " de " + moment(date, "YYYY-MM-DD").format("YYYY"))
      );
    },
    getHumanDuration(date) {
      if (date.substr(0, 10) == this.$util.hoje()) return "hoje";
      else
        {
          moment.relativeTimeRounding(Math.floor);
          return moment
            .duration(moment(date, "YYYY-MM-DD").diff(this.$util.hoje()))
            .humanize(true);
        } 
    },
    sexo(sexo) {
      return sexo == "M" ? "Masculino" : sexo == "F" ? "Feminino" : "";
    },
    idade(date) {
      return moment.duration(moment(date, "YYYY-MM-DD").diff()).humanize();
    },
    telefone(telefone) {
      let textoAjustado = "(" + telefone.st_numero.slice(0, 2) + ") ";
      if (telefone.ch_tipo_telefone == "M") {
        const parte1 = telefone.st_numero.slice(2, 7);
        const parte2 = telefone.st_numero.slice(7, 11);
        textoAjustado = textoAjustado + `${parte1}-${parte2}`;
      } else {
        const parte1 = telefone.st_numero.slice(2, 6);
        const parte2 = telefone.st_numero.slice(6, 10);
        textoAjustado = textoAjustado + `${parte1}-${parte2}`;
      }

      return textoAjustado;
    }
    // printAnamnese(dadosFormulario_) {
    //   let dadosFormulario = dadosFormulario_;
    //   this.$refs.impressaoAnamense.imprimirAnamnese(
    //     this.atendimento,
    //     dadosFormulario
    //   );
    // }
  },

  beforeMount() {
    this.modal_chave = this.$util.uuidv4();
    this.id_unidade_operacao_avulso = this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_unidade_operacao') : "";
  },

  mounted() {
    this.tamanho = this.$util.getCookie('tamanho-fonte-pep') ? this.$util.getCookie('tamanho-fonte-pep') : 'M';

    if (!this.panel) {
      if ( this.$route.meta.avulso ) {
        this.$store.commit("setBreadcrumb", [
          { name: "Avulso", path: "/" },
          { name: "Paciente", path: "/" }
        ]);
      } else if ( this.$route.meta.enfermagem && this.$route.meta.cc ) {
        this.$store.commit("setBreadcrumb", [
          { name: "Çentro Cirúrgico", path: "/centro-cirurgico/marcacao" },
          { name: "Atendimento", path: "/centro-cirurgico/atendimento" },
          { name: "Paciente", path: "/centro-cirurgico/atend" }
        ]);
      } else if ( this.$route.meta.vacina ) {
        this.$store.commit("setBreadcrumb", [
          { name: "Vacina", path: "/vacina" },
          { name: "Paciente", path: "/vacina/atend" }
        ]);
      } else if ( this.$route.meta.enfermagem ) {
        this.$store.commit("setBreadcrumb", [
          { name: "Assistência", path: "/assistencia/atend" },
          { name: "Paciente", path: "/assistencia/atend" }
        ]);
      } else { 
        this.$store.commit("setBreadcrumb", [
          { name: "Consultório", path: "/consultorio" },
          { name: "Paciente", path: "/consultorio" }
        ]);
      }
      
    }

    this.local = this.$util.getCookie('local-chamada');
    this.expandido = this.$util.getCookie('pep-comprimido') == 'true' ? false : true ;

    this.listMode = this.$util.getCookie(this.cookie_list_mode) ? this.$util.getCookie(this.cookie_list_mode) : 'L';

    this.load();
  },
  updated() {
    $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>

<style scoped>
.legadoitem { 
  line-height: 1 !important;
  margin-bottom: 0 !important;
}

.sidebar {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}

.timeline {
  list-style: none;
  padding: 20px 0 20px;
  position: relative;
}
.timeline:before {
  top: 0;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 3px;
  background-color: #eeeeee;
  left: 50%;
  margin-left: -1.5px;
}
.timeline > li {
  margin-bottom: 20px;
  position: relative;
  width: 50%;
  float: left;
  clear: left;
}
.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}
.timeline > li:after {
  clear: both;
}
.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}
.timeline > li:after {
  clear: both;
}
.timeline > li > .timeline-panel {
  width: 95%;
  float: left;
  border: 1px solid #d4d4d4;
  /*border-radius: 2px;*/
  /*padding: 20px;*/
  position: relative;
  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
}

.timeline > li > .timeline-panel:before {
  position: absolute;
  top: 26px;
  right: -15px;
  display: inline-block;
  border-top: 15px solid transparent;
  border-left: 15px solid #ccc;
  border-right: 0 solid #ccc;
  border-bottom: 15px solid transparent;
  content: " ";
}
.timeline > li > .timeline-panel:after {
  position: absolute;
  top: 27px;
  right: -14px;
  display: inline-block;
  border-top: 14px solid transparent;
  border-left: 14px solid #fff;
  border-right: 0 solid #fff;
  border-bottom: 14px solid transparent;
  content: " ";
}
.timeline > li > .timeline-badge {
  color: #fff;
  width: 24px;
  height: 24px;
  line-height: 50px;
  font-size: 1.4em;
  text-align: center;
  position: absolute;
  top: 16px;
  right: -12px;
  /*background-color: #999999;*/
  z-index: 100;
  /*
  border-top-right-radius: 50%;
  border-top-left-radius: 50%;
  border-bottom-right-radius: 50%;
  border-bottom-left-radius: 50%;
  */
}
.timeline > li.timeline-inverted > .timeline-panel {
  float: right;
}
.timeline > li.timeline-inverted > .timeline-panel:before {
  border-left-width: 0;
  border-right-width: 15px;
  left: -15px;
  right: auto;
}
.timeline > li.timeline-inverted > .timeline-panel:after {
  border-left-width: 0;
  border-right-width: 14px;
  left: -14px;
  right: auto;
}
.timeline-badge > a {
  color: #c5c7c5 !important;
}
.timeline-badge a:hover {
  color: #000 !important;
}
.timeline-title {
  margin-top: 0;
  color: inherit;
}
.timeline-body > p,
.timeline-body > ul {
  padding: 20px;
  margin-bottom: 0;
}
.timeline-body > p + p {
  margin-top: 5px;
}
.timeline-footer {
  padding: 20px;
  background-color: #f4f4f4;
}
.timeline-footer > a {
  cursor: pointer;
  text-decoration: none;
}
.tooltip {
  position: absolute;
  z-index: 1020;
  display: block;
  visibility: visible;
  padding: 5px;
  font-size: 11px;
  opacity: 0;
  filter: alpha(opacity=0);
}
.tooltip.top {
  margin-top: -2px;
}
.tooltip.right {
  margin-left: 2px;
}
.tooltip.bottom {
  margin-top: 2px;
}
.tooltip.left {
  margin-left: -2px;
}
.tooltip.top .tooltip-arrow {
  bottom: 0;
  left: 0;
  margin-left: 0;
  border-left: 0 solid transparent;
  border-right: 5px solid transparent;
  border-top: 0 solid #000;
}
.tooltip.left .tooltip-arrow {
  bottom: 0;
  left: 0;
  margin-left: 0;
  border-left: 0 solid transparent;
  border-right: 5px solid transparent;
  border-top: 0 solid #000;
}
.tooltip.bottom .tooltip-arrow {
  bottom: 0;
  left: 0;
  margin-left: 0;
  border-left: 0 solid transparent;
  border-right: 5px solid transparent;
  border-top: 0 solid #000;
}
.tooltip.right .tooltip-arrow {
  bottom: 0;
  left: 0;
  margin-left: 0;
  border-left: 0 solid transparent;
  border-right: 5px solid transparent;
  border-top: 0 solid #000;
}
.tooltip-inner {
  width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  background-color: #313131;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  border-radius: 0px;
}
.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
}
.timeline > li.timeline-inverted {
  float: right;
  clear: right;
  margin-top: 30px;
  margin-bottom: 30px;
}
.timeline > li:nth-child(2) {
  margin-top: 60px;
}
.timeline > li.timeline-inverted > .timeline-badge {
  left: -12px;
}

@media (max-width: 767px) {
  ul.timeline:before {
    left: 40px;
  }

  ul.timeline > li {
    margin-bottom: 20px;
    position: relative;
    width: 100%;
    float: left;
    clear: left;
  }
  ul.timeline > li > .timeline-panel {
    width: calc(100% - 90px);
    width: -moz-calc(100% - 90px);
    width: -webkit-calc(100% - 90px);
  }

  ul.timeline > li > .timeline-badge {
    left: 28px;
    margin-left: 0;
    top: 16px;
  }

  ul.timeline > li > .timeline-panel {
    float: right;
  }

  ul.timeline > li > .timeline-panel:before {
    border-left-width: 0;
    border-right-width: 15px;
    left: -15px;
    right: auto;
  }

  ul.timeline > li > .timeline-panel:after {
    border-left-width: 0;
    border-right-width: 14px;
    left: -14px;
    right: auto;
  }

  .timeline > li.timeline-inverted {
    float: left;
    clear: left;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .timeline > li.timeline-inverted > .timeline-badge {
    left: 28px;
  }
}
</style>

